
/*
 * Copyright (c) 2025-2026. Saddhu
 * Project: shopify-impulse
 * File: custom.js
 * Date: 2026/9/4 18:46
 * Author: Saddhu
 */


class MicasSessionStorage{
  constructor() {
    this.micasSessionKeyListKey = '@micas-session-key-list';
    this.micasSessionStorageActiveKey = '@micas-session-storage-active';
    this.micasSessionKeyList = JSON.parse(localStorage.getItem(this.micasSessionKeyListKey) || '[]')
    this.init()
  }
  init(){
    const micasSessionStorageActiveTime = JSON.parse(localStorage.getItem(this.micasSessionStorageActiveKey) || null)
    const currentTime = new Date().getTime();
    if (!micasSessionStorageActiveTime || currentTime - micasSessionStorageActiveTime > 30*60*1000){
      this.cleatMicasSessionStorage()
    }
    setInterval(() => {
      this.updateActive();
    }, 5000);
  }
  setItem(key, value){
   this.addKey(key)
   localStorage.setItem(key, value);
  }
  getItem(key){
   return localStorage.getItem(key);
  }
  setJson(key, value){
    this.addKey(key)
    localStorage.setItem(key, JSON.stringify(value));
  }
  getJson(key){
   return JSON.parse(localStorage.getItem(key) || null);
  }
  removeItem(key){
    this.removeKey(key)
    return localStorage.removeItem(key);
  }
  addKey(key){
    if (!this.micasSessionKeyList.includes(key)){
      const newMicasSessionKeyLis = [...this.micasSessionKeyList, key]
      localStorage.setItem(this.micasSessionKeyListKey, JSON.stringify(newMicasSessionKeyLis))
    }
  }
  removeKey(key){
    if (this.micasSessionKeyListKey.includes(key)){
      const [key, ...newMicasSessionKeyLis] = this.micasSessionKeyList;
      localStorage.setItem(this.micasSessionKeyListKey, JSON.stringify(newMicasSessionKeyLis))
    }
  }
  updateActive() {
    const currentTime = new Date().getTime().toString();
    localStorage.setItem(this.micasSessionStorageActiveKey, currentTime)
  }
  cleatMicasSessionStorage() {
    this.micasSessionKeyList.forEach(key => {
      localStorage.removeItem(key)
    })
    localStorage.removeItem(this.micasSessionKeyListKey)
    this.micasSessionKeyList= []
  }
}
var micasSessionStorage = new MicasSessionStorage()

//自定义滚动条
class CScrollBar extends HTMLElement {
  constructor() {
    super()
    this.scrollBox = this.querySelector('[data-scroll]')
    this.init()
  }

  init() {
    this.scrollBox.classList.add('scrollbar-hide-small')
    this.barBox = document.createElement('div')
    this.appendChild(this.barBox)
    const shadowRoot = this.barBox.attachShadow({ mode: "open" });
    shadowRoot.innerHTML = `
        <style>
          .bar{
            width: 100%;
            height: 1px;
            overflow:hidden;
            position: relative;
            display: none;
            background: #e1e1e1;
          }
          .bar-inner{
            height: 1px;
            position: absolute;
            bottom: 0;
            left: 0;
            background: #666;
          }
        </style>
        <div class="bar">
         <div class=bar-inner></div>
        </div>
      `
    this.bar = shadowRoot.querySelector('.bar')
    this.barInner = shadowRoot.querySelector('.bar-inner')
    const barColor = this.dataset.color
    const barInnerColor = this.barBox.dataset.color
    if (barColor != undefined) {
      this.bar.style.background = barColor
    }
    if (barInnerColor != undefined) {
      this.barInner.style.background = barInnerColor
    }
    this.reset()
    this.bind()
  }

  reset() {
    const multiple = this.scrollBox.clientWidth / this.scrollBox.scrollWidth
    if (multiple > 0.98) {
      this.bar.style.display = 'none'
      return false
    }
    this.bar.style.display = 'block'
    this.barInner.style.width = multiple * 100 + '%'
  }

  bind() {
    this.scrollBox.addEventListener('scroll', () => {
      const left = this.scrollBox.scrollLeft / this.scrollBox.scrollWidth
      this.barInner.style.left = left * 100 + '%'
    })
    const observer = new MutationObserver(this.reset.bind(this))
    observer.observe(this.scrollBox, { childList: false, subtree: true, attributes: true })
  }
}

customElements.define('c-scroll-bar', CScrollBar)

//移动端滑动
class CScrollDesk extends HTMLElement {
  constructor() {
    super();
    this.scrollBox = this.querySelector('[data-scroll]');
    this.isMove = false;
    this.init()
    this.observe()
  }

  init() {
    let startX = 0;
    let downX = 0
    let endX = 0;
    let movePx = 0;
    let downTime = 0;
    let upTime = 0;
    this.onmousedown = ( e ) => {
      e.preventDefault()
      startX = e.clientX;
      this.initx = this.scrollBox.scrollLeft;
      endX = startX;
      downTime = new Date().getTime();
      document.onmousemove = ( e ) => {
        e.preventDefault()
        this.isMove = true;
        endX = e.clientX;
        movePx = (endX - startX);
        this.move(movePx)
      }
      document.onmouseup = ( e ) => {
        upTime = new Date().getTime();
        if (upTime - downTime < 100) {
          this.isMove = false;
        }
        document.onmousemove = null;
        document.onmouseup = null;
      }
    }
    this.scrollBox.querySelectorAll('a').forEach(( item ) => {
      item.addEventListener('click', ( e ) => {
        if (this.isMove) {
          e.preventDefault()
          this.isMove = false;
        }
      })
    })
  }

  observe() {
    const observer = new MutationObserver(this.reset.bind(this))
    observer.observe(this.scrollBox, { childList: false, subtree: true, attributes: true })
  }

  move( px ) {
    let x = this.initx - px;
    if (x < 0) {
      x = 0
    }
    this.scrollBox.scrollTo(x, 0)
  }

  reset() {
    this.initx = this.scrollBox.scrollLeft;
  }
}

customElements.define('c-scroll-desk', CScrollDesk);

//幻灯片滑动
class CSlide extends HTMLElement {
  constructor() {
    super();
    this.slideBox = this.querySelector('[data-slide]');
    this.ctrlPrev = this.querySelector('[data-slide-prev]');
    this.ctrlNext = this.querySelector('[data-slide-next]');
    this.dotList = this.querySelectorAll('[data-slide-dot]');
    if (this.slideBox && this.ctrlPrev && this.ctrlNext) {
      this.init()
    } else {
      console.log("CSlide error")
    }
  }

  init() {
    const step = this.slideBox.dataset.slideStep || 100;
    const index = this.slideBox.dataset.slideIndex || 1;
    const pages = this.slideBox.dataset.slidePages || 1;
    const sizes = this.dotList.length || 1;
    this.step = step * 1
    this.index = index * 1
    this.pages = pages * 1
    this.sizes = sizes
    this.bind()
  }

  bind() {
    this.ctrlPrev.addEventListener('click', () => {
      this.move(-1)
    })
    this.ctrlNext.addEventListener('click', () => {
      this.move(1)
    })
    if (!!this.dotList.length) {
      this.bindDotEv();
    }

  }
  bindDotEv() {
    let scrollTimer = null;
    document.addEventListener('DOMContentLoaded', () => {
      this.setDot()
    })

    this.slideBox.addEventListener('scroll', () => {
      if (scrollTimer !== null) {
        clearTimeout(scrollTimer);
      }
      scrollTimer = setTimeout(() => {
        this.setDot()
      }, 100);
    });
  }
  setDot() {
    const sizeWidth = this.slideBox.scrollWidth / this.sizes;
    // 隐藏时候不设置
    if (sizeWidth === 0){
      return
    }
    const index = Math.round(this.slideBox.scrollLeft / sizeWidth);
    if(this?.dotList?.length){
      this.dotList.forEach(dot => {
        dot.classList.remove('current');
      })
      this.dotList[index].classList.add('current');
    }
  }
  move( tag ) {
    this.index += tag;
    if (this.index < 0) {
      this.index = 0;
    }
    if (this.index > this.pages) {
      this.index = this.pages;
    }
    this.slideBox.style.transform = `translateX(-${(this.index - 1) * this.step}%)`;
    this.hideCtrl()
  }

  hideCtrl() {
    if (this.index <= 1) {
      this.ctrlPrev.classList.add('slide-ctrl-disable')
    } else {
      this.ctrlPrev.classList.remove('slide-ctrl-disable')
    }

    if (this.index >= this.pages) {
      this.ctrlNext.classList.add('slide-ctrl-disable')
    } else {
      this.ctrlNext.classList.remove('slide-ctrl-disable')
    }
  }
}

customElements.define('c-slide', CSlide);

// 捆绑产品
class CCombinationProduct extends HTMLElement {
  constructor() {
    super();
    this.combinationBox = this.querySelector('.product-combination-wrapper')
    this.productDrawer = this.querySelector('c-product-drawer')
    this.combinationProductList = this.querySelectorAll('.combination-product')
    this.combinationProductCheckboxList = this.querySelectorAll('.combination-product-checkbox')
    this.combinationProductQuantityEl = this.querySelector('[data-combination-quantity]')
    this.combinationSubmitEl = this.querySelector('.combination-submit')
    this.combinationTotalPriceEl = this.querySelector('.combination-total-wrapper .total-price')
    this.combinationMode = this.dataset.combinationMode
    this.bind()
  }
  bind(){
    Array.from(this.combinationProductCheckboxList)?.forEach(item => {
      item.addEventListener('change', () => {
        this.updateQuantity()
        this.updateTotalPrice()
      })
    })
    Array.from(this.combinationProductList)?.forEach(combinationProduct => {
      const selector = combinationProduct.querySelector('.combination-product-sku-selector')
      const selectorMobile = combinationProduct.querySelector('.combination-product-sku-selector-mobile')
      const selectorMobileEl = combinationProduct.querySelector('.combination-product-sku-selector-mobile')
      const checkboxEl = combinationProduct.querySelector('.combination-product-checkbox')
      const imageEl = combinationProduct.querySelector('.combination-product-image')
      const priceEl = combinationProduct.querySelector('.combination-product-price')

      selector.addEventListener('change', () => {
        const selected = selector.selectedOptions[0];
        // 更新图片
        imageEl.style.backgroundImage = ` url(${ selected.dataset.variantImage })`
        checkboxEl.dataset.variantImage = selected.dataset.variantImage
        // 更新变体id
        checkboxEl.dataset.variantId = selected.dataset.variantId
        // 更新sku
        checkboxEl.dataset.variantSku = selected.dataset.variantSku
        // 更新价格
        checkboxEl.dataset.variantPrice =  selected.dataset.variantPrice
        // 更新选项信息
        checkboxEl.dataset.variantOption1 =  selected.dataset.variantOption1
        checkboxEl.dataset.variantOption2 = selected.dataset.variantOption2
        selectorMobileEl.innerHTML = selected.dataset.variantTitle
        priceEl.innerHTML = this.moneyFormat(selected.dataset.variantPrice / 100)
        this.updateTotalPrice()
      })
      selectorMobile.addEventListener('click', (ev) => {
        ev.preventDefault()
        ev.stopPropagation()
        if (this.productDrawer){
          const productDataEl = combinationProduct.querySelector('[type="application/json"][data-type="combination-product-variants"]')
          const productData = JSON.parse(productDataEl?.textContent || '{}')
          const selectedVariant = productData.variants.find(item => item.id == checkboxEl.dataset.variantId)
          //设置当前产品
          this.productDrawer.setProduct(productData, selectedVariant)
          // 打开弹窗
          this.productDrawer.open()
        }
      })
    })
    this.combinationSubmitEl.addEventListener('click', () => {
      const checkedCheckbox = Array.from(this.combinationProductCheckboxList)?.filter(item => item.checked) || [];
      const checkedData = Array.from(checkedCheckbox).map(item => {
        const spu = item.dataset.spu
        const index = item.dataset.index * 1
        const variantId = item.dataset.variantId
        const variantSku = item.dataset.variantSku
        const variantPrice = item.dataset.variantPrice
        const variantImage = item.dataset.variantImage
        const variantOption1 = item.dataset.variantOption1
        const variantOption2 = item.dataset.variantOption2
        return { index, spu, variantId, variantPrice, variantImage,  variantSku, variantOption1, variantOption2}
      })
      this.submit(checkedData)
    })
    this.productDrawer.onSubmit = (product, selectedVariant) => {
      const selector = this.querySelector(`.combination-product-sku-selector[data-spu="${product.handle}"]`)
      selector.value = selectedVariant.id
      const event = new Event('change');
      selector.dispatchEvent(event);
    }
  }
  updateQuantity() {
    const checkedCheckbox = Array.from(this.combinationProductCheckboxList)?.filter(item => item.checked) || 0;
    this.combinationProductQuantityEl.dataset.combinationQuantity = checkedCheckbox.length.toString();
    this.combinationProductQuantityEl.innerHTML = checkedCheckbox.length ? `(${checkedCheckbox.length})` : '';
    this.combinationSubmitEl.disabled = !checkedCheckbox.length;
  }
  updateTotalPrice() {
    const checkedCheckbox = Array.from(this.combinationProductCheckboxList)?.filter(item => item.checked) || [];
    const totalPrice = checkedCheckbox.reduce((acc, cur) => {
      if (cur.dataset.variantPrice) {
        return acc + cur.dataset.variantPrice * 1
      }else {
        return acc
      }
    }, 0)
    this.combinationTotalPriceEl.innerHTML = this.moneyFormat(totalPrice / 100)
  }
  moneyFormat(amount){
    return window.theme.settings.moneyFormat.replace(`{{amount}}`, amount.toFixed(2))
  }
  submit(data) {
    if (this.combinationSubmitEl.classList.contains('btn--loading') || !theme.routes.cartAdd || !data.length){
      return
    }
    this.combinationSubmitEl.classList.add('btn--loading');
    document.dispatchEvent(new CustomEvent('combinationProduct:submit', {
      detail: {
        productList: data,
        combinationMode: this.combinationMode
      }
    }));
    const items = data.map(item => ({id: item.variantId, quantity: 1}));
    const formData = { items };
    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData),
    })
      .then(response => response.json())
      .then((data)=> {
        if (data.items) {
          this.addSuccess(data.items)
        } else {
          this.addError(data)
        }
      })
      .catch((err)=>{
        console.log(err)
      })
      .finally(()=>{
        this.combinationSubmitEl.classList.remove('btn--loading');
      })
  }
  addSuccess(items) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        productList: items.map(item =>({product:item, sku: item.sku}))
      }
    }));
  }
  addError(data) {
    console.debug('失败')
  }
}
customElements.define('c-combination-product', CCombinationProduct);

// 产品抽屉
class CProductDrawer extends HTMLElement {
  constructor() {
    super();
    this.submitEl = this.querySelector('.combination-drawer-submit');
    this.titleEl = this.querySelector('.combination-drawer-title')
    this.option1WrapperEl = this.querySelector('.combination-drawer-option1');
    this.option2WrapperEl = this.querySelector('.combination-drawer-option2');
    this.option1NameEl = this.querySelector('.combination-drawer-option1 .combination-drawer-option-title .option-name');
    this.option2NameEl = this.querySelector('.combination-drawer-option2 .combination-drawer-option-title .option-name');
    this.option1ValueEl = this.querySelector('.combination-drawer-option1 .combination-drawer-option-title .option-value');
    this.option2ValueEl = this.querySelector('.combination-drawer-option2 .combination-drawer-option-title .option-value');
    this.option1ValuesWrapperEl = this.querySelector('.combination-drawer-option1 .combination-drawer-option-values');
    this.option2ValuesWrapperEl = this.querySelector('.combination-drawer-option2 .combination-drawer-option-values');
    this.bind()
  }
  render(){
    this.titleEl.innerHTML = this.product.title
    this.option1NameEl.innerHTML =  this.option1Name
    this.option1ValueEl.innerHTML = this.selectedVariant?.option1
    let option1InnerHtml = ''
    let option2InnerHtml = ''
    if (this?.option1Name?.toLowerCase() === 'color'){
      this.option1ValuesWrapperEl.classList.add('is-color')
      this.option1list.forEach(item => {
        const featured_image =  this.product.variants.find(variant => variant.option1 === item)?.featured_image
        option1InnerHtml += `
          <li class="combination-drawer-option-item ${this.selectedVariant?.option1 == item ? 'selected' : ''}" data-value="${item}">
             <img src="${featured_image.src}" alt="">
          </li>`
      })
    } else {
      this.option1ValuesWrapperEl.classList.remove('is-color')
      this.option1list.forEach(item => {
        option1InnerHtml += `
          <li class="combination-drawer-option-item ${this.selectedVariant?.option1 == item ? 'selected' : ''}" data-value="${item}">
            ${item}
          </li>`
      })
    }
    if (this.option2Name){
      this.option2WrapperEl.classList.remove('hide')
      this.option2NameEl.innerHTML = this.option2Name
      this.option2ValueEl.innerHTML = this.selectedVariant?.option2
      this.option2list.forEach(item => {
        option2InnerHtml += `<li class="combination-drawer-option-item ${this.selectedVariant?.option2 == item ? 'selected' : ''}" data-value="${item}">${item}</li>`
      })
    }else {
      // 移除选项2
      this.option2WrapperEl.classList.add('hide')
    }
    this.option1ValuesWrapperEl.innerHTML = option1InnerHtml
    this.option2ValuesWrapperEl.innerHTML = option2InnerHtml
    this.submitEl.disabled = !this.selectedVariant?.available
    if (!this.selectedVariant){
      this.submitEl.innerHTML = "Unavailable"
    } else if (!this.selectedVariant?.available){
      this.submitEl.innerHTML = "Sold Out"
    } else {
      this.submitEl.innerHTML = "Update To Bag"
    }

  }
  bind(){
    this.submitEl.addEventListener('click', () => {
      if (this.onSubmit){
        this.onSubmit(this.product, this.selectedVariant)
      }
      this.close()
    })
  }
  bindOptions() {
    const option1ELs = this.option1ValuesWrapperEl.querySelectorAll('.combination-drawer-option-item')
    const option2ELs = this.option2ValuesWrapperEl.querySelectorAll('.combination-drawer-option-item')
    option1ELs.forEach(item => {
      item.addEventListener('click', () => {
        const option = item.dataset.value
        this.selectedOption1 = option
        this.option1ValueEl.innerHTML = option
        const variant = this.product.variants.find(item => item.option1 === option && item.option2 === this.selectedOption2)
        this.selectedVariant = variant;
        this.submitEl.disabled = !variant?.available
        if (!variant){
          this.submitEl.innerHTML = "Unavailable"
        } else if (!variant.available){
          this.submitEl.innerHTML = "Sold Out"
        } else {
          this.submitEl.innerHTML = "Update To Bag"
        }
        option1ELs.forEach(i => i.classList.remove('selected'))
        item.classList.add('selected')
      })
    })

    option2ELs?.forEach(item => {
      item.addEventListener('click', () => {
        const option = item.dataset.value
        this.selectedOption2 = option
        this.option2ValueEl.innerHTML = option
        const variant = this.product.variants.find(item => item.option2 === option && item.option1 === this.selectedOption1)
        this.selectedVariant = variant
        this.submitEl.disabled = !variant?.available
        if (!variant){
          this.submitEl.innerHTML = "Unavailable"
        } else if (!variant.available){
          this.submitEl.innerHTML = "Sold Out"
        } else {
          this.submitEl.innerHTML = "Update To Bag"
        }
        option2ELs.forEach(i => i.classList.remove('selected'))
        item.classList.add('selected')
      })
    })
  }
  setProduct(product, selectedVariant) {
    this.product = product
    this.selectedVariant = selectedVariant
    const option1Variants = this.product.variants.map(item => item.option1)
    const option2Variants = this.product.variants.map(item => item.option2)
    this.option1Name = product.options[0]
    this.option2Name = product.options?.[1] || ''
    this.option1list = [...new Set(option1Variants)];
    this.option2list = [...new Set(option2Variants)];
    this.selectedOption1 = selectedVariant.option1
    this.selectedOption2 = selectedVariant.option2
    this.render()
    this.bindOptions()
  }
  open() {
    if (theme?.CombinationDrawer){
      theme.CombinationDrawer.open()
    }
  }
  close() {
    if (theme?.CombinationDrawer){
      theme.CombinationDrawer.close()
    }
  }
}
customElements.define('c-product-drawer', CProductDrawer);

// 搜索记录
~function () {
  const searchHistoryStr = localStorage.getItem('searchHistory') || "[]"
  const searchHistory = JSON.parse(searchHistoryStr);

  function searchHistorySave( searchName = '', searchHref = '' ) {
    let name = searchName.trim().slice(0, 25);
    let href = searchHref.trim();
    href = href.replace('https://shopmicas.com/', '/');
    searchHistory.forEach(( search, index ) => {
      if (search.name === name && search.href === href) {
        searchHistory.splice(index, 1)
      }
    })
    if (name !== '' && href !== '') {
      searchHistory.push({
        name: name,
        href: href
      })
    }
    if (searchHistory.length > 20) {
      searchHistory.shift();
    }
    localStorage.setItem('searchHistory', JSON.stringify(searchHistory))
  }

  const historyContainer = document.querySelector('.search-history');
  if (historyContainer) {
    const listContainer = historyContainer.querySelector('.search-history-list');
    if (searchHistory.length) {
      const fragment = document.createDocumentFragment()
      const searchHistoryShow = JSON.parse(searchHistoryStr);
      searchHistoryShow.reverse().forEach(( h, index ) => {
        let li = document.createElement('li');
        const href = encodeURI(h.href)
        li.innerHTML = `<a href=${href} target="_self" data-matomo="search_history" data-matomo-name="${h.name}" 
data-matomo-index="${index}">${h.name}</a>`
        fragment.appendChild(li)
      })
      listContainer.appendChild(fragment)
      historyContainer.classList.remove('hide')
    }
  }

  const keywords = document.querySelectorAll('#keyword-list li > a')
  keywords.forEach(k => {
    k.addEventListener("click", () => {
      searchHistorySave(k.textContent, k.href)
    })
  })

  const historyKeywords = document.querySelectorAll('.search-history-list li > a')
  historyKeywords.forEach(k => {
    k.addEventListener("click", () => {
      searchHistorySave(k.textContent, decodeURI(k.href))
    })
  })

  const searchForms = document.querySelectorAll('form.search-bar')
  searchForms.forEach(form => {
    form.addEventListener('submit', ( e ) => {
      const q = form.querySelector('input[name="q"]')
      let name = q.value || ''
      const href = `${window.theme.routes.market}/search?type=product&options[prefix]=last&q=${name}`;
      searchHistorySave(name, href)
    })
  })


}()

// 保存url折扣码用户自动填写
~function () {
  const params = new URLSearchParams(window.location.search)
  const discount = params.get('discount')
  if (discount) {
    sessionStorage.setItem("URLCustomDiscount", discount)
  }
}()

//复制
function copyCode( code, callback = () => {
} ) {
  if (navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code)
      .then(() => {
        callback()
      })
      .catch(err => console.log(err));
  } else if (document.execCommand) {
    const textValue = document.createElement('textarea');
    textValue.classList.add('copy-textValue')
    textValue.setAttribute('readonly', 'readonly'); //设置只读属性防止手机上弹出软键盘
    textValue.value = code;
    document.body.appendChild(textValue); //将textarea添加为body子元素
    textValue.select();
    document.execCommand('copy');
    document.body.removeChild(textValue);//移除DOM元素
    callback()
  }
}

// 复制文本
~function () {
  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll("[data-copy-dom]").forEach(item => {
      item.addEventListener('click', () => {
        const code = item.dataset.copyDom
        code && copyCode && copyCode(code, () => {
          document.dispatchEvent(new CustomEvent('copied', { detail: { element: item } }))
        })
      })
    })
  })
}()

// 顶部菜单 用户icon
~function () {
  const userIcon = document.querySelector('.site-nav-user')
  if (!userIcon) return;
  userIcon.addEventListener('click', () => {
    if (!window?.customer?.id){
      location.href = `/account/login?return_to=${encodeURIComponent('/pages/micas-rewards')}&m_form=headerIcon`
      return
    }
    if (userIcon.classList.contains('js-open')) {
      userIcon.classList.remove('js-open')
    } else {
      userIcon.classList.add('js-open')
      userIcon.dispatchEvent(
        new CustomEvent('drawerOpen', {
          bubbles: true,
          cancelable: true
        })
      );
    }
  })
  document.addEventListener('click', ( ev ) => {
    const target = ev.target;
    if (!target.closest('.site-nav-user')) {
      userIcon.classList.remove('js-open')
    }
  })
}()

// 收藏插件回调函数
function wishlistCallback( response ) {
  const event = response.event;
  const product = response.product;
  if (event === "ADD") {
    document.dispatchEvent(new CustomEvent('addToWishlist', {
      detail: {
        product: product,
        sku: product.variants.sku
      }
    }))
  } else if (event === 'REMOVE') {
    document.dispatchEvent(new CustomEvent('removeWishlist', {
      detail: {
        product: product,
        sku: product.variants.sku
      }
    }))
  } else if (event === 'MOVETOCART') {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: product,
        sku: product.variants.sku
      }
    }));
  }
}

var Bytem = window.Bytem || {};
Bytem.onload = Bytem.onload || [];

// bytem 购物车推荐产品
~function () {
  class CBytemCart extends HTMLElement {
    constructor() {
      super();
      this.platform = matchMedia("screen and (max-width: 769px)").matches ? 'm' : 'pc';
      this.cartListIds = [];
      this.bytemUrl = "https://server001.recommend-display.bytem.com/cart"
      this.env = "shopmicas"
      this.cacheKey = 'CBytemCartData';
      this.userControlCacheKey = 'CBytemCartUserControl';
      this.firstRender = true
    }

    init() {
      const localUid = localStorage.getItem('shopmicas/cly_id');
      const uid = window.Bytem?.cookieId || localUid || '';
      if (uid) {
        this.uid = uid;
        this._init()
      } else {
        let bytemFlag = true
        // 未获取ID 则使用回调
        console.log('bytem not id,use callback')
        Bytem.onload.push(( self ) => {
          this.uid = self.cookieId;
          console.log('bytem callback', self.cookieId)
          // 判断是否超时
          if (bytemFlag) {
            console.log('bytem callback')
            bytemFlag = false
            this._init()
          }
        });
        // 超时设置
        setTimeout(() => {
          if (this.uid == '' || bytemFlag) {
            console.log('bytem callback timeout')
            bytemFlag = false
            this.showShopify(true)
          }
        }, 2000)
      }
    }

    _init() {
      const userControl = sessionStorage.getItem(this.userControlCacheKey);
      console.log('check cache bytemControl', userControl)
      if (userControl === 'true') {
        this.showShopify(true);
        return
      }
      // 获取购物车行id列表
      const cartListIds = this.getCartListIds();
      let localCache = null;
      // 判断购物车是否有变更
      // 先判断长度不相等,或者首次渲染,需要更新
      if (this.cartListIds.length !== cartListIds.length || this.firstRender) {
        this.cartListIds = cartListIds;
        // 检查本地bytem数据缓存
        this.checkLocalCache();
      } else {
        // 合并去重后判断长度来判断元素是否有变化,
        const setSize = new Set([...cartListIds, ...this.cartListIds]).size;
        // 长度相等则无变化
        if (setSize === this.cartListIds.length) {
          return
        }
        // 否则检查缓存
        this.cartListIds = cartListIds;
        this.checkLocalCache();
      }
    }

    getCartListIds() {
      // 获取当前购物车handle数据
      let cartListIds = []
      const cart_items = document.querySelector('#CartDrawer .drawer__inner .cart__items');
      if (cart_items) {
        const cartListIdsStr = cart_items.dataset?.cartItemIds || '';
        cartListIds = cartListIdsStr.split(',');
      }
      return cartListIds
    }

    checkLocalCache() {
      let localCache = null
      const CBytemCartDataStr = sessionStorage.getItem(this.cacheKey);
      let CBytemCartData = [];
      if (!!CBytemCartDataStr) {
        CBytemCartData = JSON.parse(CBytemCartDataStr)
      }
      if (CBytemCartData.length > 0) {
        localCache = CBytemCartData.find(item => item.idList.join(',') === this.cartListIds.join(','))
      }
      // 判断是否有缓存数据
      if (localCache) {
        console.log("use bytem cache")
        this.updateProductList(localCache.bytemList)
      } else {
        console.log("no bytem cache,update... save...")
        this.updateBytemList(this.cartListIds);
      }
    }


    updateBytemList( cartIds ) {
      //更新bytem缓存
      fetch(this.bytemUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        mode: 'cors',
        body: JSON.stringify({
          version: "v1",
          env: this.env,
          apikey: "1fa79ce72a1f4b38966179f5ab880f59",
          uid: this.uid,
          cart: cartIds,
          platform: this.platform,
          size: 20
        })
      })
        .then(( response ) => {
          return response.json();
        })
        .then(( data ) => {
          if (!data || data.control === true || !data.products || !data.products.length) {
            this.showShopify(true)
            console.log('save cache bytemControl', data.control)
            sessionStorage.setItem(this.userControlCacheKey, data.control);
          } else {
            console.log('save cache bytemControl', data.control)
            sessionStorage.setItem(this.userControlCacheKey, data.control);
            const bytemListHandles = data.products.map(item => item.handle);
            // 更新缓存信息
            const CBytemCartDataStr = sessionStorage.getItem(this.cacheKey);
            let CBytemCartData = [];
            if (!!CBytemCartDataStr) {
              CBytemCartData = JSON.parse(CBytemCartDataStr)
            }
            CBytemCartData.push({
              idList: cartIds,
              bytemList: bytemListHandles,
            })
            if (CBytemCartData.length > 10) {
              CBytemCartData.shift()
            }
            sessionStorage.setItem(this.cacheKey, JSON.stringify(CBytemCartData));
            // 更新产品列表
            this.updateProductList(bytemListHandles)
          }
        })
        .catch(( error ) => {
          this.showShopify(true)
          console.error("bytem", error)
        });
    }

    updateProductList( handles ) {
      fetch(`${window.theme.routes.market}/collections/all?view=ajax_cart&sort_by=${handles.join(',')}`, {
        method: 'GET',
      })
        .then(( response ) => response.text())
        .then(( responseText ) => {
          this.renderProducts(responseText)
        })
        .catch(() => {
          this.showShopify(true)
        });
    }

    renderProducts( data ) {
      // 切换首次渲染tag
      this.firstRender = false;
      const html = new DOMParser().parseFromString(data, 'text/html')
      const collectionEl = html.getElementById('collection_ajax');
      const bytemContainer = this.querySelector('[data-custom-product-bytem] .custom-products-container');
      if (bytemContainer) {
        const customProductItem = collectionEl.querySelectorAll('.custom-product-item');
        if (customProductItem.length <= 0) {
          this.showShopify(true);
          return;
        }
        bytemContainer.innerHTML = collectionEl.innerHTML;
        this.showShopify(false)
        if (window.cartDrawer) {
          window.cartDrawer.cartForm.initVariantSelect(bytemContainer);
          window.cartDrawer.cartForm.initAdd2Cart(bytemContainer);
        }
        if (window.AOS) {
          AOS.refreshHard()
        }
      } else {
        this.showShopify(true)
      }
    }

    showShopify( flag ) {
      const shopifyBox = this.querySelector('[data-custom-product]');
      const bytemBox = this.querySelector('[data-custom-product-bytem]');
      if (flag) {
        shopifyBox.classList.remove('hide')
        bytemBox.classList.add('hide')
      } else {
        shopifyBox.classList.add('hide')
        bytemBox.classList.remove('hide')
      }
    }
  }

  customElements.define('c-bytem-cart', CBytemCart);
}()

// 买赠弹窗
~function () {

	class VariantSelector {
		constructor(wrapper) {
			this.wrapper = wrapper;
			this.option1RadioList = this.wrapper.querySelectorAll('.js-variant-option1-input');
			this.option1LabelList = this.wrapper.querySelectorAll('.js-variant-option1-label');
			this.option2RadioList = this.wrapper.querySelectorAll('.js-variant-option2-input');
			this.option2LabelList = this.wrapper.querySelectorAll('.js-variant-option2-label');
			this.variantId =  this.wrapper.dataset.variantId * 1;
			this.spu = this.wrapper.dataset?.spu;
			this.index = this.wrapper.dataset?.index;
      this.onOption1Change= null;
      this.onOption2Change = null
      this.init()
		}
		init() {
			const productVariantsDataEl = this.wrapper.querySelector('[type="application/json"][data-type="product_variants"]');
			if (productVariantsDataEl) {
				this.variants = JSON.parse(productVariantsDataEl.textContent) || {};
			} else {
				this.variants = {}
			}
			this.variant = this.variants.find(variant => variant.id == this.variantId)
      this.onChangeVariant = (currentVariant, optionIndex, optionValue, target) => {
        document.dispatchEvent(new CustomEvent('variant:change:buyGet', {detail: {
            variant: currentVariant,
            optionIndex,
            optionValue,
            target: target,
        }}));
      }
			this.bindEvent();
      this.checkAvailable()
		}

		bindEvent(){
			this.option1RadioList.forEach(option1Radio => {
        option1Radio.addEventListener('change', ev => {
					this.changeVariant({ option1: ev.target.value }, ev.target)
          if (this.onOption1Change) {
            this.onOption1Change(ev)
          }
				})
			})
			this.option2RadioList.forEach(option2Radio => {
				option2Radio.addEventListener('change', ev => {
					this.changeVariant({ option2: ev.target.value }, ev.target)
          if (this.onOption2Change) {
            this.onOption2Change(ev)
          }
				})
			})
		}
		changeVariant( { option1, option2 }, target ) {
			let currentVariant = null;
			if (option1) {
				currentVariant = this.variants.find(variant => {
					return variant.option1 === option1 && variant.option2 === this.variant.option2;
				})
			} else if (option2) {
				currentVariant = this.variants.find(variant => {
					return variant.option2 === option2 && variant.option1 === this.variant.option1;
				})
			}
			if (currentVariant) {
				this.variant = currentVariant;
        this.variantId = currentVariant.id;
				this.wrapper.dataset.variantId = currentVariant.id
				this.checkAvailable();
			}
      const optionIndex = option1 ? 0 : 1;
      const optionValue = option1 || option2;
			this.onChangeVariant(currentVariant, optionIndex, optionValue, target)
		}

		checkAvailable(){
			this.renderOption1Available();
			this.renderOption2Available();
		};

		renderOption1Available() {
			const currentOption2 = this.variant.option2;
			const option1AvailableArr = this.variants.reduce((options, variant) => {
				const key = variant.option1;
				//默认为不可用状态
				if ( options[key] == undefined){
					options[key] = false;
				}
				//当option2与当前option2相同时，更新对应option1可用性
				if(variant.option2 == currentOption2 || currentOption2 == null ){
					options[key] = variant.available;
				}
				return options;
			}, {})
			this.option1RadioList.forEach(e=>{
				const opt = e.value;
				e.disabled = !option1AvailableArr[opt];
			})
			this.option1LabelList.forEach(e=>{
				const opt = e.dataset.value;

				if(option1AvailableArr[opt]){
					e.classList.remove('disabled');
				}else{
					e.classList.add('disabled');
				}
			})
		};

		renderOption2Available () {
			const currentOption1 = this.variant.option1;
			const option2AvailableArr = this.variants.reduce((options, variant) => {
				const key = variant['option2'];
				//默认为不可用状态
				if ( options[key] == undefined){
					options[key] = false;
				}
				//当option1与当前option1相同时，更新对应option2可用性
				if(variant['option1'] == currentOption1 || currentOption1 == null){
					options[key] = variant.available;
				}
				return options;
			}, {});
			this.option2RadioList?.forEach(e=>{
				const opt = e.value;
				e.disabled = ! option2AvailableArr[opt];
			})
			this.option2LabelList?.forEach(e=>{
				const opt = e.dataset.value;
				if(option2AvailableArr[opt]){
					e.classList.remove('disabled');
				}else{
					e.classList.add('disabled');
				}
			})
		};

    addToCart() {
      const variant = this.variant;
      const formData = {
        items: [{
          id: variant.id,
          quantity: 1
        }]
      };
      if (theme && theme?.routes?.cartAdd) {
        return fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData),
        })
      }else {
        return null
      }
    }

	}
  class BuyGetProduct {
    constructor( wrapper ) {
      this.wrapper = wrapper
      this.productMainWrapper =  this.wrapper.querySelector('.js-BGProduct-main')
      this.productMainImageDom = this.wrapper.querySelector('.js-BGProduct-image');
      this.addBtn = this.wrapper.querySelector('.js-BGProduct-add-btn');
      this.init();
    }

    init() {
      this.variantSelector =  new VariantSelector(this.wrapper);
      this.variantSelector.onOption1Change = (ev) => {
        const image = ev.target.dataset.image;
        if (image) {
          this.productMainImageDom.src = '';
          this.productMainImageDom.src = image
        }
      }
      this.bindEvent();
    }

    bindEvent() {
      this.addBtn.addEventListener('click', () => {
        if (this.addBtn.classList.contains('active') && !this.addBtn.classList.contains('btn--loading')) {
          this.addBtn.classList.add('btn--loading');
          const sku = this.variantSelector.variant.sku;
          document.dispatchEvent(new CustomEvent('buyGetAdd', {
            detail: {
              variant: this.variantSelector.variant,
              index: this.variantSelector?.index,
              spu: this.variantSelector?.spu,
            }
          }));
          this.variantSelector.addToCart()
            .then(response => response.json())
            .then(( data ) => {
              if (data.status === 422) {
                theme.cart.addError(data, sku);
              } else {
                theme.cart.addSuccess(data.items[0], sku);
              }
            })
            .finally(() => {
            this.addBtn.classList.remove('btn--loading');
          })
        }
      })
    }
    toggleDisabled( tag ) {
      if (tag) {
        this.addBtn.classList.remove('active');
      } else {
        this.addBtn.classList.add('active');
      }
    }

    mainClick = ( cb ) => {
      this.productMainWrapper.addEventListener('click', () => {
        cb && cb();
      })
    }
  }

	class BuyGetProductDrawer {
		constructor() {
			this.wrapper = document.querySelector('#BuyGetDrawer')
			this.addBtn = this.wrapper.querySelector('.js-BGProduct-add-btn');
			this.productScroll = this.wrapper.querySelector('.js-BGProduct-scroll');
			this.productList = this.wrapper.querySelectorAll('.js-BGProduct-product');
			this.variantElList = this.wrapper.querySelectorAll('.js-BGProduct-product-variant');
			this.productImageElList = this.wrapper.querySelectorAll('.js-BGProduct-image');
      if (this.wrapper){
        this.init();
      }
		}
		init() {
			this.currentIndex = 1;
			this.bindEvent()
		}
		bindEvent() {
      const closeBtn = this.wrapper.querySelector('.js-drawer-close');
      closeBtn.addEventListener('click', () => {
        console.log('关闭');
        sessionStorage.setItem('buy_gey_modal_close', new Date().getTime().toString());
      })
      this.variantSelectorList = [];
      this.variantElList.forEach((variantEl, index) => {
        const variantSelector = new VariantSelector(variantEl)
        variantSelector.onOption1Change = (ev) => {
          const image = ev.target.dataset.image;
          if (image) {
            this.productImageElList[index].src = '';
            this.productImageElList[index].src = image
          }
        }
        this.variantSelectorList.push(variantSelector);
      })
			this.productList.forEach((productEl, index) => {
				productEl.addEventListener('touchstart', ()=> {
					this.setProductElHeight()
          this.productChange(index)
				})
			})
      this.addBtn.addEventListener('click', () => {
        const variantSelector = this.variantSelectorList[this.currentIndex - 1];
        if (!this.addBtn.classList.contains('btn--loading')) {
          this.addBtn.classList.add('btn--loading');
          const sku = variantSelector.variant.sku;
          document.dispatchEvent(new CustomEvent('buyGetAdd', {
            detail: {
              variant: variantSelector.variant,
              index: variantSelector?.index,
              spu: variantSelector?.spu,
            }
          }));
          variantSelector
            .addToCart()
            .then(response => response.json())
            .then(( data ) => {
              if (data.status === 422) {
                theme.cart.addError(data, sku);
              } else {
                theme.BuyGetDrawer.close();
                theme.cart.addSuccess(data.items[0], sku);
              }
            })
            .finally(() => {
              this.addBtn.classList.remove('btn--loading');
            })
        }
      })
		}
    setProductElHeight() {
      if (!this.productElRect) {
        this.productElRect = this.productList[0].getBoundingClientRect();
        this.productScroll.style.height = this.productElRect.height + 'px';
      }
    }
    productChange(index) {
      this.currentIndex = index + 1;
      this.productList.forEach((item, i) => {
        if (i === index){
          item.classList.add('product-active')
        }else{
          item.classList.remove('product-active')
        }
      })
      this.productScroll.style.transform = `translateX(${ 27 - 40 * index }%)`
      this.variantElList.forEach(item => {
        item.classList.add('hide')
      })
      this.variantElList[index].classList.remove('hide')
    }

	}

  window.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('.buy-get-wrapper')) return
    if(window.matchMedia("(max-width: 768px)").matches){
      // 移动端
      new BuyGetProductDrawer()
    } else {
      const buyGetProductItemList = document.querySelectorAll('#BuyGetModal .js-BGProduct-item');
      // 产品卡片实例化数组
      const buyGetProductItemInstantList = [];
      // 根据产品卡片节点 实例化产品卡片
      buyGetProductItemList?.forEach(buyGetProductItem => {
        buyGetProductItemInstantList.push(new BuyGetProduct(buyGetProductItem))
      })
      // 遍历产品卡片实例绑定切换事件
      buyGetProductItemInstantList.forEach(buyGetProductItemInstant => {
        // 主产品点击
        buyGetProductItemInstant.mainClick(() => {
          if (!buyGetProductItemInstant.disable) {
            // 排除所有
            buyGetProductItemInstantList.forEach(innerBuyGetProductItemInstant => {
              innerBuyGetProductItemInstant.toggleDisabled(true)
            })
            // 设置自己
            buyGetProductItemInstant.toggleDisabled(false)
          }
        })
      })
      // 关闭事件
      const closeBtn = document.querySelector('#BuyGetModal .js-modal-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          sessionStorage.setItem('buy_gey_modal_close', new Date().getTime().toString());
        })
      }
    }
  })
}()


// 加载完手动触发一次滚动事件
~function () {
  window.addEventListener('load', ()=> {
    window.dispatchEvent(new Event('scroll'));
  })
}()


// 加载完计算列表米快宽度
~function () {
  function checkColorQuantityMax(wrapper) {
    const gridItem = wrapper.querySelector('.grid__item');
    if(!gridItem) {return}
    const gridItemWidth = gridItem.getBoundingClientRect().width;
    let quantity = Math.floor(gridItemWidth / (24+8));
    if (quantity > 1){
      quantity = quantity > 8 ? 8 : quantity;
      wrapper.dataset.colorMax = (quantity-1) + '';
    }
  }

  function debounce(wait, func) {
    let timeoutId;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    }
  }
  window.addEventListener('DOMContentLoaded', ()=> {
    const collectionWrapper =  document.querySelector('.collection-grid__wrapper');
    if(!collectionWrapper){return}
    checkColorQuantityMax(collectionWrapper);

    const debounceCheckColorQuantityMax = debounce(300, checkColorQuantityMax)
    window.addEventListener('resize', () => {
      debounceCheckColorQuantityMax(collectionWrapper)
    })
    document.querySelectorAll('input[name="collection-layout"]').forEach(item => {
      item.addEventListener('change', () => {
        debounceCheckColorQuantityMax(collectionWrapper)
      })
    })

  })

}()
// 下载引导
~function () {
  window.addEventListener('DOMContentLoaded',()=>{
    // const downloadBar = document.querySelector('.app-download-bar');
    const closeBtns = document.querySelectorAll('.app-download-bar .download-bar-close span, .app-download-bar .download-bar-get a');
    // const sessionDownloadBarTime = sessionStorage.getItem('showDownloadBar');
    // if (!sessionDownloadBarTime) {
    //   downloadBar.classList.remove('hide');
    //   window.dispatchEvent(new Event('resize'));
    // }
    if(document.documentElement.classList.contains('has-download-bar')){
      closeBtns.forEach(item => {
        item.addEventListener('click', ()=> {
          document.documentElement.classList.remove('has-download-bar');
          window.dispatchEvent(new Event('resize'));
          sessionStorage.setItem('showDownloadBar', new Date().getTime().toString())
        })
      })
    }
  })
}()

// PC端顶部菜单滚动
~function (){
  window.addEventListener('DOMContentLoaded', ()=> {
    const wrapper = document.querySelector('.header-item--navigation-wrapper');
    const navigationEl = document.querySelector('.header-item--navigation-wrapper .site-navigation-wrapper');
    const scrollEl = document.querySelector('.header-item--navigation-wrapper .site-navigation-scroll');
    const prev = document.querySelector('.header-item--navigation-wrapper .site-navigation-scroll__prev');
    const next = document.querySelector('.header-item--navigation-wrapper .site-navigation-scroll__next');
    // 计算超出的长度
    const clacScroll = () => {

      // 超出的长度
      let overLength = 0;
      if(wrapper && navigationEl) {
        overLength = navigationEl.clientWidth - wrapper.clientWidth
        if(overLength > 0) {
          scrollEl.classList.remove('hide');
          navigationEl.style.marginLeft = '0';
          next.classList.remove('disabled');
          prev.classList.add('disabled');
          // 超出长度添加按钮的长度
          overLength += scrollEl.clientWidth;
        } else {
          scrollEl.classList.add('hide');
          navigationEl.style.marginLeft = 'auto';
        }
      }
      return overLength;
    }
    let overLength = clacScroll();
    // 监听窗口变化重新计算,并且添加节流
    let timer = null;
    window.addEventListener('resize', () => {
      if(timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        // 重新计算
        overLength = clacScroll();
      }, 500)
    })
    // 暂时只用最前与最后
    prev.addEventListener('click', () => {
      navigationEl.style.marginLeft = '0';
      next.classList.remove('disabled');
      prev.classList.add('disabled');
    })
    next.addEventListener('click', () => {
      console.log(overLength)
      navigationEl.style.marginLeft = `-${overLength}px`;
      prev.classList.remove('disabled');
      next.classList.add('disabled');
    })
  })
}()

// 评论viewAll 打开时间更新
~function (){
  window.addEventListener('DOMContentLoaded', ()=> {
    const el = document.querySelector('#c_custom_review .more-review-wrapper .reviews_all');
    const drawerEl = document.querySelector('#ReviewsAllDrawer');
     if(el && drawerEl){
       el.addEventListener('drawerOpen', () => {
         drawerEl.dataset.openTime = new Date().getTime() + '';
       })
     }
  })
}()


//闪购活动
~function (){
  window.addEventListener('DOMContentLoaded', ()=> {

    class Flipper {
      constructor(wrapper, initCount) {
        this.wrapper = wrapper;
        this.isFlipping=false
        this.frontNode = wrapper.querySelector('.front')
        this.backNode = wrapper.querySelector('.back')
        this.max = wrapper.dataset.max || 9
        this.setFront(initCount)
      }
      setFront(number){
        this.count = number
        this.frontNode.dataset.number=number
      }
      setBack(number){
        this.backNode.dataset.number=number
      }
      set(nextCount) {
        if (this.isFlipping || this.count === nextCount) {
          return false
        }
        this.wrapper.classList.add('active')
        this.setBack(nextCount)
        this.isFlipping = true
        setTimeout(() => {
          this.wrapper.classList.remove('active')
          this.isFlipping = false
          this.setFront(nextCount)
        }, 600)
      }
    }

    class ClockFlipper {
      constructor(wrapper, remainingTime) {
        this.wrapper = wrapper;
        this.getEl()
        this.init(remainingTime);
      }
      getEl(){
        this.hourTenthEl = this.wrapper.querySelector('[data-time=hour-tenth]')
        this.hourOnesEl = this.wrapper.querySelector('[data-time=hour-ones]')
        this.minuteTenthEl = this.wrapper.querySelector('[data-time=minute-tenth]')
        this.minuteOnesEl = this.wrapper.querySelector('[data-time=minute-ones]')
        this.secondTenthEl = this.wrapper.querySelector('[data-time=second-tenth]')
        this.secondOnesEl = this.wrapper.querySelector('[data-time=second-ones]')
      }
      init(remainingTime) {
        const hours = Math.floor(remainingTime / (1000 * 60 * 60));
        const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
        const {hourTenth, hourOnes, minuteTenth, minuteOnes, secondTenth, secondOnes } = this.formatTime(hours, minutes, seconds)
        this.hourTenthFlipper = new Flipper (this.hourTenthEl, hourTenth);
        this.hourOnesFlipper = new Flipper (this.hourOnesEl, hourOnes);
        this.minuteTenthFlipper = new Flipper (this.minuteTenthEl, minuteTenth);
        this.minuteOnesFlipperl = new Flipper (this.minuteOnesEl, minuteOnes);
        this.secondTenthFlipper = new Flipper (this.secondTenthEl, secondTenth);
        this.secondOnesFlipper = new Flipper (this.secondOnesEl, secondOnes);
      }
      formatTime(hours, minutes, seconds) {
        const hourTenth = Math.floor(hours / 10);
        const hourOnes = hours % 10;
        const minuteTenth = Math.floor(minutes / 10);
        const minuteOnes = minutes % 10;
        const secondTenth = Math.floor(seconds / 10);
        const secondOnes = seconds % 10;
        return{
          hourTenth,
          hourOnes,
          minuteTenth,
          minuteOnes,
          secondTenth,
          secondOnes,
        }
      }
      set(hours, minutes, seconds) {
        const {hourTenth, hourOnes, minuteTenth, minuteOnes, secondTenth, secondOnes } = this.formatTime(hours, minutes, seconds)
        this.hourTenthFlipper.set(hourTenth)
        this.hourOnesFlipper.set(hourOnes)
        this.minuteTenthFlipper.set(minuteTenth)
        this.minuteOnesFlipperl.set(minuteOnes)
        this.secondTenthFlipper.set(secondTenth)
        this.secondOnesFlipper.set(secondOnes)
      }
    }

    window.flashSale = window?.flashSale || {}
    window.flashSale.flashSaleEls =  window.flashSale?.flashSaleEls || []
    window.flashSale.flashSaleTimeEls =  window.flashSale?.flashSaleTimeEls || []
    window.flashSale.flashSaleTimeCountdownObj =  window.flashSale?.flashSaleTimeCountdownObj || []
    const { enable, startTime, duration, infinity } = window.flashSale
    // 确保格式为两位数;
    const formatTime = (value) => value.toString().padStart(2, '0');
    // 计算剩余时间
    const calcRemainingTime = () => {
      let remainingTime = 0;
      const durationTime = duration * 60 * 60 * 1000;
      const beijingTime = new Date(startTime);
      const startTimestamp = beijingTime.getTime();
      const nowTimestamp = new Date().getTime();
      if (startTimestamp > nowTimestamp) {
        // 活动未开始
        return remainingTime;
      } else if (infinity) {
        // 计算从开始时间到当前时间的总经过时间
        const elapsedTime = nowTimestamp - startTimestamp;
        // 在经过的时间中取模 duration 时间段，以实现循环计算
        remainingTime = durationTime - (elapsedTime % durationTime);
      } else {
        remainingTime = (startTimestamp + durationTime) - nowTimestamp;
      }
      return remainingTime;
    }

    if(!enable){
      return false
    }
    try{
      let remainingTime = calcRemainingTime();
      if (remainingTime > 0) {
        const productFlashSaleEls = document.querySelectorAll('.product-flash-sale-wrapper, .flash-sale-time-wrapper');
        const productFlashSaleTimeEls = document.querySelectorAll('.flash-sale-time');
        const productFlashSaleTimeCountdownEls = document.querySelectorAll('.flash-sale-countdown') || [];
        flashSale.flashSaleEls = [
          ...flashSale.flashSaleEls,
          ...productFlashSaleEls
        ]
        flashSale.flashSaleTimeEls = [
          ...flashSale.flashSaleTimeEls,
          ...productFlashSaleTimeEls
        ]
        flashSale.flashSaleTimeCountdownObj = [
          ...flashSale.flashSaleTimeCountdownObj,
          ...Array.from(productFlashSaleTimeCountdownEls)?.map(item => new ClockFlipper(item, remainingTime))
        ]
        flashSale.flashSaleEls.forEach(item => item.classList.add('flash-sale'))

        const timer = setInterval(() => {
          const hours = Math.floor(remainingTime / (1000 * 60 * 60));
          const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
          const timeStr = `${formatTime(hours)}H : ${formatTime(minutes)}M : ${formatTime(seconds)}S`;
          flashSale.flashSaleEls.forEach(item => item.classList.add('flash-sale'))
          flashSale.flashSaleTimeEls.forEach(item => item.innerHTML = timeStr)
          flashSale.flashSaleTimeCountdownObj.forEach(item => item.set(hours, minutes, seconds))
          remainingTime -= 1000;
          if (remainingTime <= 0) {
            if(infinity) {
              remainingTime = duration * 60 * 60 * 1000
            } else {
              console.log('闪购结束')
              flashSale.flashSaleEls.forEach(item => item.classList.remove('flash-sale'))
              clearInterval(timer);
            }
          }
        }, 1000);
        // 集合页重新
        document.addEventListener("collection:reloaded", () => {
          flashSale.flashSaleEls = document.querySelectorAll('.product-flash-sale-wrapper') || [];
          flashSale.flashSaleTimeEls = document.querySelectorAll('.flash-sale-time') || [];
        })
        // 集合页加载更多
        document.addEventListener("collection:fetchMore", () => {
          flashSale.flashSaleEls = document.querySelectorAll('.product-flash-sale-wrapper') || [];
          flashSale.flashSaleTimeEls = document.querySelectorAll('.flash-sale-time') || [];
        })
        document.addEventListener("featured:fetchMore", () => {
          flashSale.flashSaleEls = document.querySelectorAll('.product-flash-sale-wrapper') || [];
          flashSale.flashSaleTimeEls = document.querySelectorAll('.flash-sale-time') || [];
        })
        // 商品详情页推荐
        document.addEventListener("productRecommendation:fetchComplete", () => {
          flashSale.flashSaleEls = document.querySelectorAll('.product-flash-sale-wrapper') || [];
          flashSale.flashSaleTimeEls = document.querySelectorAll('.flash-sale-time') || [];
        })
      }
    } catch (e){
      console.debug('闪购函数异常', e)
    }
  })
}()

//micas 管理器
class MicasManager {
  static loading = false;
  static logged = false;
  static accessToken = null;
  static customer = window?.customer || {};
  static shopifyLogged = !!window?.customer?.id;
  constructor() {
    this.basisURL = window?.Shopify?.shop === 'shopmicas.myshopify.com' ? 'https://service.themicas.com/api' : 'https://service-dev.themicas.com/api'
    this.loginBasisURL = window?.Shopify?.shop === 'shopmicas.myshopify.com' ? 'https://api.themicas.com' : 'https://api-dev.decimalpoint.com.cn'
    this.overtime = 5 * 1000;
    this.loginOvertime = 5 * 1000;
    this.login().catch()
  }
  // 登录
  async login() {
    if (MicasManager.loading || !MicasManager.shopifyLogged) {
      return
    }
    try {
      MicasManager.loading = true
      const { email } = MicasManager.customer
      const catchAccessToken = this.getCatchAccessToken(email);
      if (catchAccessToken){
        MicasManager.accessToken = catchAccessToken
        MicasManager.logged = true;
      } else {
        const newAccessToken = await this.updateAccessToken()
        MicasManager.accessToken = newAccessToken
        MicasManager.logged = true;
        document.dispatchEvent(new CustomEvent('micasManagerLogin'));
      }
    } catch (error) {
      console.log(error)
    } finally {
      MicasManager.loading = false
    }
  }
  // 读取缓存Token
  getCatchAccessToken( customerEmail ) {
    const catchAccessToken = JSON.parse(sessionStorage.getItem('@micas-service-token') || '{}');
    if (
      catchAccessToken?.token
      && catchAccessToken?.customerEmail === customerEmail
      && catchAccessToken.expireTime > new Date().getTime() + 60 * 1000
    ) {
      return catchAccessToken
    } else {
      return null
    }
  }
  // 更新Token
  async updateAccessToken() {
    const url = `${this.loginBasisURL}/user/login/signIn`;
    const {id, email, micasKey} =  MicasManager.customer
    const controller = new AbortController();
    const timer = setTimeout(() => {
      controller.abort();
    }, this.loginOvertime);
    try {
      const result = await fetch(url, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
        // 客户端类型(1:app; 2:shopify;)
        body: JSON.stringify({
          d: id,
          t: micasKey,
          c: 2
        })
      }).then(res => res.json())
      if (result?.code !== 200 || !result.data) {
        throw new Error(result?.msg);
      }
      const newAccessToken = result.data;
      sessionStorage.setItem('@micas-service-token', JSON.stringify({ ...newAccessToken, customerEmail: email }))
      MicasManager.accessToken = newAccessToken
      return newAccessToken
    } catch (error) {
      if (error.name === 'AbortError'){
        console.debug('Request timed out')
      }else {
        console.debug('service login error', error)
      }
      throw error
    } finally {
      clearTimeout(timer);
    }
  }
  // 请求
  async query( url, params, method ) {
    const fetchUrl = `${this.basisURL}/${url}`;
    try {
      let result = await this._sendRequest(fetchUrl, params, method);
      if (result?.code === 401){
        // 更新令牌
        await this.updateAccessToken();
        result = await this._sendRequest(fetchUrl, params, method);
      }
      if (result?.code !== 200) {
        const error =  new Error(result.msg);
        error.name = result.code;
        throw error;
      }
      return result
    }  catch (error) {
      throw error
    }
  }
  // 发送请求
  async _sendRequest(fetchUrl, params, method) {
    const controller = new AbortController();
    const timer = setTimeout(() => {
      controller.abort();
    }, this.overtime);
    try {
      const accessToken = MicasManager.accessToken;
      const response = await fetch(fetchUrl, {
        method: method || 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken?.token}`,
        },
        body: JSON.stringify(params),
        signal: controller.signal,
      });
      clearTimeout(timer);
      return await response.json();
    } catch (error){
      if (error.name === 'AbortError'){
        throw new Error('Request timed out',);
      }
      throw error
    }
  }
}


//micas 收藏管理器
class MicasWishlistManager extends MicasManager{
  constructor(){
    super();
    this.basisURL = window?.Shopify?.shop === 'shopmicas.myshopify.com' ? 'https://api.themicas.com/goods' : 'https://api-dev.decimalpoint.com.cn/goods'
    this.overtime = 5 * 1000;
    // 1 pc, 2 mobile
    this.channel = theme.config.bpSmall ? 2: 1;
  }
  // 添加收藏
  async addWish (productId, variantId) {
    try {
      const result = await this.query('wishlist/add', {
        channel: this.channel,
        shopifyProductId: productId,
        shopifyVariantId: variantId,
      })
      if (result.code ===200){
        return true;
      }
    } catch (error){
      throw error
    }
  }

  // 移除收藏
  async removeWish (productId, variantId) {
    try {
      const result = await this.query('wishlist/cancel', {
        channel: this.channel,
        shopifyProductId: productId,
        shopifyVariantId: variantId,
      })
      if (result.code === 200){
        return true;
      }
    } catch (error){
      throw error
    }
  }
  // 获取产品收藏状态
  async getProductWishState (idList){
    try {
      const result = await this.query('wishlist/isAdd', {
        shopifyVariantIdList: idList,
      })
      return result?.data?.filter(item=>item.add)?.map(i=>i.shopifyVariantId) || []
    } catch (error){
      console.debug('getProduct wishlist error', error)
      return []
    }
  }
  // 获取分页产品数据
  async getWishPage (endCursor = '', keyword=''){
    try {
      let wishList = await this._getWishPageData(endCursor, keyword);
      const accumulatedPageData = [];
      while (true) {
        const {pageData} = wishList;
        const wishHandleList= pageData?.map(item => item.spu?.toLowerCase());
        const productInfoList = await this.getProductListInfo(wishHandleList);
        const formatedPageData =  this.mapWishlistInfo(pageData, productInfoList)
        //过滤下架产品
        const availablePageData = formatedPageData.filter(item => item !== undefined && item !== null);
        accumulatedPageData.push(...availablePageData);
        // 当前批次存在无效商品时继续请求下一批，并保留各批次的有效商品
        if (availablePageData.length < pageData.length && wishList.hasNextPage) {
          wishList = await this._getWishPageData(wishList.endCursor, keyword);
          continue;
        }
        return {
          ...wishList,
          pageData: accumulatedPageData
        }
      }
    } catch (error){
      console.debug('getPage wishlist error', error)
    }
  }
  // 获取分页数据
  async _getWishPageData (endCursor = '', keyword=''){
    try {
      const pageSize= 8;
      const isSearch = !!keyword.trim()?.length;
      let allData = []
      // 如果没有游标,则请求全量数据并缓存
      if (!endCursor){
        allData = await this._getWishAllData(keyword);
        // 分情况保存数据
        if (isSearch){
          this.wishSearchAllData = allData
        } else {
          this.wishAllData = allData
        }
      } else {
        // 有游标,则使用缓存数据
        allData =  this.wishAllData
        if (isSearch){
          allData =  this.wishSearchAllData
        }
      }
      // 获取分页数据
      const pageData = this.paginate(allData, pageSize, endCursor);
      return {
        ...pageData,
        isSearch: isSearch,
      }
    } catch (error){
      console.debug('getPage wishlist error', error)
    }
  }
  // 获取全量数据
  async _getWishAllData (keyword=''){
    try {
      let url ='wishlist/page'
      if (keyword.trim()?.length) {
        url = 'wishlist/search';
      }
      const isSearch = !!keyword.trim()?.length;
      const result = await this.query(url, { pageNum: 1, pageSize: 500, ...(keyword?{keyword: keyword}:{})});
      const allData = result.data.records || []
      return allData.map(item =>({
        ...item,
        cursor: item.shopifyVariantId,
        isSearch: isSearch
      }));
    } catch (error){
      console.debug('getPage wishlist error', error)
    }
  }
  // 收藏移入购物车
  async wishMoveToCart (productId, variantId, sku) {
    try{
      await this.addCart(variantId, sku)
      await this.removeWish(productId, variantId)
      return true
    } catch (err){
      this.addCartError(err, sku)
      throw err
    }
  }
  // 获取shopify产品数据
  async getProductListInfo (handleList) {
    return Promise.all(
      handleList.map(handle => (
        fetch(`${window.Shopify.routes.root}products/${handle}.js`)
          .then(response => {
            return response?.ok ? response?.json(): {}
          })
      ))
    )
  }
  // 添加购物车
  async addCart(variantId, sku) {
    const formData = {
      items: [{
        id: variantId,
        quantity: 1
      }]
    };
    const response = await fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData),
    })
    const data = await response.json()
    const item = data.items?.[0];
    if (item?.id) {
      this.addCartSuccess(item, sku)
      return item
    } else {
      throw new Error('Add To Cart Fail')
    }
  }
  // 加购成功
  addCartSuccess(product,sku) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: product,
        sku:sku
      }
    }));
  }
  // 加购失败
  addCartError(error,sku) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
      detail: {
        errorMessage: error.description,
        sku:sku
      }
    }));
  }
  // 分页工具函数
  paginate(allData, pageSize, endCursor ) {
    if(!endCursor) {
      const pageData = allData.slice(0, pageSize);
      const hasNextPage = allData.length > pageSize;
      return {
        pageData,
        hasNextPage,
        endCursor: pageData[pageData.length - 1]?.cursor || '',
      };
    }
    const startIndex = allData.findIndex(i => i.cursor === endCursor) + 1;
    const pageData = allData.slice(startIndex, startIndex + pageSize);
    const hasNextPage = startIndex + pageSize < allData.length;
    return {
      pageData,
      hasNextPage,
      endCursor: pageData[pageData.length - 1]?.cursor || '',
    };
  }
  // 格式化产品数据函数
  mapWishlistInfo (wishList, productInfoList) {
    return wishList?.map(item => {
      const product = productInfoList.find(p => p?.id == item?.shopifyProductId)
      if (!product){
        return null
      }
      const variant = product.variants.find(v => v?.id == item?.shopifyVariantId)
      if(variant){
        return {
          ...item,
          id: product.id,
          handle: product.handle,
          title: product.title,
          sku: variant.sku,
          variantId: variant.id,
          variantTitle: variant.title,
          available: variant.available,
          imageSrc: variant.featured_image?.src || product.featured_image || '',
          option1: variant.option1,
          option2: variant.option2,
          price: variant.price,
          compareAtPrice: variant.compare_at_price,
        }
      }
    })
  }
}
// micas 收藏产品状态管理器
class MicasWishProductStateManager extends MicasWishlistManager{
  constructor(wrapper) {
    super();
    this.wrapper = wrapper
    this.btnLoading= false
    if (!wrapper || wrapper?.dataset.wishlistInit === 'done'){
      return
    }
    this.wishlistBtn = wrapper.querySelector('.wishlist-button');
    this.variantWishlistIdList = [];
    if(!this.wishlistBtn){
      return
    }
    if (!MicasManager.shopifyLogged){
      this.bindShopifyLogin()
      return
    }
    if (MicasManager.logged){
      this.init().catch()
    } else {
      document.addEventListener('micasManagerLogin', this.init.bind(this))
    }
    this.errorMsgBox = this.wrapper.querySelector('.wishlist-error-msg')
  }
  bindShopifyLogin(){
    const btn = this.wishlistBtn
    btn.addEventListener('click', () =>
      window?.theme?.WishlistLoginModal?.open()
    )
  }
  // 初始化
  async init() {
    this.wrapper.dataset.wishlistInit = 'done';
    this.productId = this.wrapper.dataset.productId;
    const variantIdListStr = this.wrapper.querySelector('.data-product-variant-id-list')?.textContent || '[]';
    const variantIdList = JSON.parse(variantIdListStr)?.map(i => i+'');
    // 查询收藏列表
    this.variantWishlistIdList = await this.getProductWishState(variantIdList);
    // 初始设置
    const currentVariantId = this.wrapper.dataset.currentId;
    this.setVariantState(currentVariantId);
    this.bindVariantChange();
    this.bindBtnClick();
  }
  // 绑定点击
  bindBtnClick (){
    const btn = this.wishlistBtn
    btn.addEventListener('click', () => {
      if (this.btnLoading){
        return
      }
      this.btnLoading = true;
      try {
        const wishlistState = btn.dataset.wishlistState;
        const currentVariantId = this.wrapper.dataset.currentId;
        this.errorMsgBox.classList.add('hide')
        if (wishlistState === 'added'){
          // 移除
          this.removeWish(this.productId, currentVariantId).catch((err) => {
            this.showDetailErrorMsgBox(err)
          })
          document.dispatchEvent(new CustomEvent('wishRemove', {
            detail: {
              target: btn,
            }
          }));
          this.variantWishlistIdList = this.variantWishlistIdList.filter(id => id !== currentVariantId);
          btn.dataset.wishlistState = 'none'
        } else if (wishlistState === 'none'){
          // 添加
          this.addWish(this.productId, currentVariantId).catch((err) => {
            this.showDetailErrorMsgBox(err)
          })
          this.variantWishlistIdList.push(currentVariantId);
          document.dispatchEvent(new CustomEvent('wishAdd', {
            detail: {
              target: btn,
            }
          }));
          btn.dataset.wishlistState = 'added'
        }
      } catch (error){
        console.debug(error)
      }finally {
        setTimeout(() => {
          this.btnLoading = false
        }, 300)
      }
    })
  }
  // 变体切换
  bindVariantChange () {
    this.wrapper.addEventListener('variantChange', (ev) => {
      const variantId = '' + ev.detail?.variant?.id;
      this.setVariantState(variantId)
      this.errorMsgBox.classList.add('hide')
    })
  }
  // 设置状态
  setVariantState(variantId) {
    const added = this.variantWishlistIdList?.includes(variantId)
    if (added){
      this.wishlistBtn.dataset.wishlistState = 'added'
    }else {
      this.wishlistBtn.dataset.wishlistState = 'none'
    }
  }
  // 显示商品详情页错误信息
  showDetailErrorMsgBox (error) {
    if(!this.errorMsgBox) return
    const basicsErrorMsg = 'Failed to save, please try again later.';
    const limitErrorMsg = "Oops! You've reached the limit inyour wishlist. Maybe it's time toreview your favorites?";
    this.errorMsgBox.innerHTML = error.name === 1000 ? limitErrorMsg : basicsErrorMsg;
    this.errorMsgBox.classList.remove('hide')
  }
}
// micas 收藏产品
class wishProductItem {
  constructor(micasWishlistManager, productInfo) {
    this.micasWishlistManager = micasWishlistManager
    this.productInfo = productInfo
    this.loading = false
    this.render()
    this.bind()
  }
  render(){
    const { handle,sku, title, option1, option2, imageSrc, variantId, variantTitle, compareAtPrice, price, isSearch,available } = this.productInfo;
    this.dom = document.createElement('div')
    if(isSearch){
      this.dom.classList.add('product-list-item', 'product-list-item-search')
    } else {
      this.dom.classList.add('product-list-item', 'product-list-item-page')
    }
    this.dom.dataset.matomo= 'product-list-item';
    this.dom.dataset.matomoName= handle;
    this.dom.dataset.matomoIndex='1';
    this.dom.dataset.matomoUrl= imageSrc;
    this.dom.dataset.matomoSku= sku;
    this.dom.dataset.matomoSize= option2;
    this.dom.dataset.matomoColor= option1;
    this.dom.dataset.matomoPrice= (price/100).toFixed(2);
    let priceHtml = `<span class="sale-price">$${(price/100).toFixed(2)}</span>`;
    if(compareAtPrice > price){
      const discount = Math.round(((compareAtPrice - price)* 100 / compareAtPrice))
      priceHtml= `
          <span class="sale-price has-discount">
            $${(price/100).toFixed(2)} (-${discount}%)
          </span>
          <span class="original-price">$${(compareAtPrice/100).toFixed(2)}</span>
        `
    }
    const image = imageSrc.replace(/(\.[^.]*)$/, "_{width}x$1");
    this.dom.innerHTML = `
        <div class="product-list-item-close-btn">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64">
            <path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/>
          </svg>
        </div>
        <a class="product-list-item-link" href='/products/${handle}?variant=${variantId}'>
          <img
            class="product-list-item-img lazyload"
            data-src="${image}"
            data-widths="[150,200,300,400,500]"
            data-sizes="auto"
            alt="">
        </a>
        <a class="product-list-item-title" href="/products/${handle}?variant=${variantId}">
          ${title}
        </a>
        <div class="product-list-item-price">${priceHtml}</div>
        <div class="product-list-item-options">${variantTitle}</div>
        <div class="product-list-item-add2cart-btn ${available ? '' : 'sold-out'}" data-id=${variantId} data-available="${available}"> ${available ? 'MOVE TO BAG' : 'SOLD OUT'}</div>
      `
  }
  bind(){
    const removeBtn = this.dom.querySelector('.product-list-item-close-btn')
    const addBtn = this.dom.querySelector('.product-list-item-add2cart-btn');
    const linkEls = this.dom.querySelectorAll('.product-list-item-title, .product-list-item-link')
    removeBtn.addEventListener('click', () => {
      this.remove()
    })
    addBtn.addEventListener('click', () => {
      if(addBtn.dataset.available !== 'true') return
      this.move()
    })
    linkEls.forEach(item => {
      item.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('wishItemCLick', {
          detail: {
            target: this.dom,
          }
        }));

      })
    })
  }
  async remove(){
    if(this.loading){
      return
    }
    this.loading=true
    this.dom.classList.add('item-loading')
    const {id, variantId} = this.productInfo;
    try{
      document.dispatchEvent(new CustomEvent('wishRemove', {
        detail: {
          target: this.dom,
        }
      }));
      await this.micasWishlistManager.removeWish(id, variantId)
      this.dom.remove()
      document.dispatchEvent(new CustomEvent('wishProductRemoveSuccess', {
        detail: {
          productInfo: this.productInfo,
        }
      }));
    } catch(err){
      document.dispatchEvent(new CustomEvent('wishProductRemoveError', {
        detail: {
          productInfo: this.productInfo,
          err: err
        }
      }));
      console.log('移除失败')
    }finally {
      this.loading=false
      this.dom.classList.remove('item-loading')
    }
  }
  async move(){
    if(this.loading){
      return
    }
    this.loading=true
    this.dom.classList.add('item-loading')
    const {id, variantId, sku} = this.productInfo;
    try{
      document.dispatchEvent(new CustomEvent('wishMoveToCart', {
        detail: {
          target: this.dom,
        }
      }));
      await this.micasWishlistManager.wishMoveToCart(id, variantId, sku)
      this.dom.remove()
      document.dispatchEvent(new CustomEvent('wishProductMoveSuccess', {
        detail: {
          productInfo: this.productInfo,
        }
      }));
    } catch(err){
      document.dispatchEvent(new CustomEvent('wishProductMoveError', {
        detail: {
          productInfo: this.productInfo,
          msg: err.msg
        }
      }));
    }finally {
      this.dom.classList.remove('item-loading')
      this.loading=false
    }
  }
}
// 交易优化优惠券
class MicasTransactionOptimizationManager extends MicasManager {
  constructor(wrapper, openStatus) {
    super()
    if(!openStatus){
      return
    }
    this.wrapper = wrapper
    this.basisURL =  window?.Shopify?.shop === 'shopmicas.myshopify.com' ? 'https://api.themicas.com' : 'https://api-dev.decimalpoint.com.cn'
    this.overtime = 5 * 1000
    this.isGroupA = window?.customerGroupOps === 'A'
    // 定时器管理
    this.timers = {
      timeout: null,
      cartQuponModal: null,
      cartDrawer: null
    }

    // 加载状态管理
    this.loadingStatus = {
      createTriggerRecord: false,
      issueRecord: false
    }

    // DOM 元素缓存
    this.elements = {
      transactionOptimizationCoupon: wrapper.querySelector('.drawer__cart-transaction-optimization-coupon'),
      quponModal: document.getElementById('CartCouponModal'),
      subtotal: wrapper.querySelector('[data-subtotal]')
    }

    // 初始化子元素
    if (this.elements.quponModal) {
      this.elements.quponModalCloseBtn = this.elements.quponModal.querySelector('.close')
      this.elements.quponModalMainButtons = this.elements.quponModal.querySelectorAll('.cart-coupon-modal-main-button')
      this.elements.copyBtn = this.elements.quponModal.querySelector('.copy-btn')
      this.elements.collectionBtn = this.elements.quponModal.querySelector('.collection-btn')
    }

    // 记录数据
    this.lastRecordData = {
      allowTrigger: 'false',
      lastValidTriggerRecordResponse: null,
      lastValidIssueRecordResponse: null
    }

    // 触发类型枚举
    this.TriggerType = {
      NEW_CUSTOMER: 3,          // 已登录未下单(新用户)
      OLD_CUSTOMER: 4,          // 已登录老用户
      SHOPIFY_UNSUBSCRIBED: 5,  // 已登录Shopify未订阅
    }

    // 触发类型配置映射。controlThreshold 保持当前线上 B 组的触发条件；
    // amountTiers 仅用于 A 组，并映射为发券接口的 rewardTier。
    this.triggerTypeObj = {
      [this.TriggerType.NEW_CUSTOMER]: {
        value: 'newCustomer',
        title: 'First-Order Deal',
        controlThreshold: 80,
        amountTiers: [
          { min: 60, max: 80, rewardTier: 1 },
          { min: 80, max: 140, rewardTier: 2 },
          { min: 140, max: null, rewardTier: 3 }
        ]
      },
      [this.TriggerType.OLD_CUSTOMER]: {
        value: 'oldCustomer',
        title: 'Exclusive VIP Gift',
        controlThreshold: 100,
        amountTiers: [
          { min: 60, max: 100, rewardTier: 1 },
          { min: 100, max: 160, rewardTier: 2 },
          { min: 160, max: null, rewardTier: 3 }
        ]
      },
      [this.TriggerType.SHOPIFY_UNSUBSCRIBED]: {
        value: 'shopifyUnsubscribed',
        title: 'Limited-Time Offer!',
        controlThreshold: 100,
        amountTiers: [
          { min: 60, max: 100, rewardTier: 1 },
          { min: 100, max: 160, rewardTier: 2 },
          { min: 160, max: null, rewardTier: 3 }
        ]
      }
    }

    // 防抖处理
    this.debouncedHandleDrawerCloseBefore = this.debounce(this.handleDrawerCloseBefore.bind(this), 300)

    // 初始化
    if (MicasManager.logged) {
      this.init()
    } else {
      document.addEventListener('micasManagerLogin', this.init.bind(this))
    }
  }

  // 添加防抖方法
  debounce(func, wait) {
    let timeoutId;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    }
  }

  async init() {
    try {
      this.setAllowTriggerStatus()
      this.setSubscribeStatus()

      // 绑定事件
      this.bindEvents()
    } catch (error) {
      console.debug('初始化失败:', error)
    }
  }

  bindEvents() {
    // 关闭按钮事件
    if (this.elements.quponModalCloseBtn) {
      this.elements.quponModalCloseBtn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.closeQuponModal()
      })
    }

    // 按钮点击事件
    this.bindQuponModalMainButton()
    this.bindCopyBtn()

    // 抽屉事件
    if (this.wrapper) {
      this.wrapper.addEventListener('drawerOpen', this.handleDrawerOpen.bind(this))
      this.wrapper.addEventListener('drawerClose', this.clearAllInterval.bind(this))
    }

    document.addEventListener('cart:updated', this.determineTriggerType.bind(this))

    // 全局事件
    document.addEventListener('drawerClickTransactionOptimizationCoupon.CartDrawer', this.cartQuponModalOpen.bind(this))

    document.addEventListener('drawerCloseBefore.CartDrawer', this.debouncedHandleDrawerCloseBefore)
  }

  async handleDrawerOpen() {
    this.setCartDrawerCouponBanner()
    this.setTimeStatus('false')
    if (this.lastRecordData.allowTrigger === 'true') {
      this.timers.timeout = setTimeout(() => {
        this.setTimeStatus('true')
        this.determineTriggerType()
      }, 0)
    }
  }

  clearAllInterval() {
    // 清理所有定时器
    Object.values(this.timers).forEach(timer => {
      if (timer) clearInterval(timer)
    })
    this.timers = {
      timeout: null,
      cartQuponModal: null,
      cartDrawer: null
    }
  }

  async handleDrawerCloseBefore() {
    try {
      clearInterval(this.timers.timeout)
      if (this.loadingStatus.createTriggerRecord || this.loadingStatus.issueRecord) return
      const computedTriggerType = this.wrapper.dataset.computedTriggerType
      if(computedTriggerType === 'null') return
      document.dispatchEvent(new CustomEvent('transactionOptimizationCouponConditionmet', {
        detail: {
          dataset:{
            matomo: 'cart#@#conditionmet',
            matomoColor: this.triggerTypeObj[computedTriggerType].title,
            matomoName: 'cart_not_ordered',
            matomoIndex: computedTriggerType,
            matomoDisable:''
          },
        }
      }));
      this.loadingStatus.createTriggerRecord = true
      const { quponModal } = this.elements
      const triggerType = this.triggerTypeObj[computedTriggerType].value
      const triggerRule = this.getTriggerRule(computedTriggerType, this.getCartAmount())
      const rewardTier = this.isGroupA && triggerRule ? triggerRule.rewardTier : null
      quponModal.classList.add(triggerType,'trigger')
      quponModal.style.display = 'flex'
      this.createTriggerRecord(computedTriggerType, rewardTier).then(res => {
        this.lastRecordData.lastValidTriggerRecordResponse = res.data
        this.handleTriggerCoupon(quponModal, this.lastRecordData.lastValidTriggerRecordResponse)
        this.setCartDrawerCouponBanner()
      }).catch(error => {
        console.debug('获取触发记录失败:', error)
        this.wrapper.dataset.computedTriggerType = 'null'
        quponModal.style.display = 'none'
        return window.cartDrawer.close()
      }).finally(() => {
        this.loadingStatus.createTriggerRecord = false
      })
    } catch (error) {
      console.debug('处理抽屉关闭前事件失败:', error)
      if (this?.wrapper){
        this.wrapper.dataset.computedTriggerType = 'null'
      }
      if (this?.elements?.quponModal){
        this.elements.quponModal.style.display = 'none'
      }
    }
  }

  createTriggerRecord(triggerType, rewardTier){
    const abTestGroup = this.isGroupA ? 1 : 2
    const clientType = 3 // 2:APP; 3:WEB
    return this.query('operation/behaviorReward/create/triggerRecord', {
      triggerType,
      abTestGroup,
      clientType,
      rewardTier
    }, 'post')
  }

  getCartAmount() {
    const subtotal = Number(this.elements.subtotal?.dataset?.subtotal)
    const currencyRate = Number(window?.Shopify?.currency?.rate) || 1
    if (!isFinite(subtotal)) return 0
    return Number(((subtotal / 100) / currencyRate).toFixed(2))
  }

  getTriggerRule(triggerType, cartAmount) {
    const triggerConfig = this.triggerTypeObj[triggerType]
    if (!triggerConfig) return null
    if (!this.isGroupA) {
      return cartAmount >= triggerConfig.controlThreshold ? triggerConfig : null
    }
    return triggerConfig.amountTiers.find(({ min, max }) => {
      return cartAmount >= min && (max === null || cartAmount < max)
    })
  }

  determineTriggerType() {
    this.wrapper.dataset.computedTriggerType = 'null'
    const { subscribeStatus, allowTrigger, timeStatus } = this.wrapper.dataset
    if (allowTrigger !== 'true' || timeStatus !== 'true') return

    const ordersCount = Number(MicasManager.customer.orders_count)
    const cartAmount = this.getCartAmount()
    const { TriggerType } = this

    // 新用户优先使用首单弹窗；未订阅和老客仅在已有订单时参与后续判断。
    if (ordersCount === 0 && this.getTriggerRule(TriggerType.NEW_CUSTOMER, cartAmount)) {
      this.wrapper.dataset.computedTriggerType = TriggerType.NEW_CUSTOMER
    } else if (ordersCount > 0 && subscribeStatus === 'not-subscribed' && this.getTriggerRule(TriggerType.SHOPIFY_UNSUBSCRIBED, cartAmount)) {
      this.wrapper.dataset.computedTriggerType = TriggerType.SHOPIFY_UNSUBSCRIBED
    } else if (ordersCount > 0 && this.getTriggerRule(TriggerType.OLD_CUSTOMER, cartAmount)) {
      this.wrapper.dataset.computedTriggerType = TriggerType.OLD_CUSTOMER
    }

  }

  async cartQuponModalOpen() {
    try {
      const { lastValidTriggerRecordResponse: triggerRecord, lastValidIssueRecordResponse: issueRecord } = this.lastRecordData
      const modalEl = this.elements.quponModal
      modalEl.style.display = 'flex'

      if (issueRecord?.rewardCode) {
        this.handleReceivedCoupon(modalEl, triggerRecord, issueRecord)
      } else {
        this.handleTriggerCoupon(modalEl, triggerRecord)
      }
    } catch (error) {
      console.debug('打开优惠券模态框失败:', error)
    }
  }

  handleReceivedCoupon(modalEl, triggerRecord, issueRecord) {
    modalEl.classList.remove('trigger')
    modalEl.classList.add(this.triggerTypeObj[triggerRecord.triggerType].value, 'receive')

    const containerEl = modalEl.querySelector('.code-modal-main-coupon-receive')
    if (!containerEl) return
    const elements = {
      rewardCode: containerEl.querySelector('.rewardCode'),
      codeReceive: containerEl.querySelector('.code-modal-main-coupon-code-receive'),
      codeReceiveBox: containerEl.querySelector('.code-modal-main-coupon-rewardCode-box'),
      codeReceiveMainButton: this.elements.quponModal.querySelector('.cart-coupon-modal-main-button.receive'),
      copyBtn: this.elements.copyBtn,
      collectionBtn: this.elements.collectionBtn
    }

    this.updateCouponDisplay(elements, triggerRecord, issueRecord)
  }

  handleTriggerCoupon(modalEl, triggerRecord) {
    modalEl.classList.remove('receive')
    modalEl.classList.add(this.triggerTypeObj[triggerRecord.triggerType].value, 'trigger')

    this.timers.cartQuponModal = this.setTimeCountDown(
      '#CartCouponModal .cart-coupon-modal-footer-countdown',
      triggerRecord.triggerEndTime,
      'cartQuponModal'
    )

    const containerEl = modalEl.querySelector(`.cart-coupon-modal-main-item.${this.triggerTypeObj[triggerRecord.triggerType].value}`)
    const errorEl = containerEl.querySelector('.cart-coupon-modal-main-error')
    errorEl.classList.add('hide')
    if (!containerEl) return

    this.updateTriggerDisplay(containerEl, triggerRecord)
  }

  updateCouponDisplay(elements, triggerRecord, issueRecord) {
    elements.copyBtn.classList.remove('copied')

    const { rewardValueType, rewardValue, rewardPrerequisiteMinSubtotal, entitledCollectionUrlList } = triggerRecord
    const couponText = this.formatCouponText(rewardValueType, rewardValue, rewardPrerequisiteMinSubtotal)
    if (elements.rewardCode) elements.rewardCode.textContent = issueRecord.rewardCode
    if (elements.codeReceive) elements.codeReceive.textContent = couponText

    elements.codeReceiveMainButton.dataset.matomoSize = couponText
    elements.codeReceiveMainButton.dataset.matomoColor = this.triggerTypeObj[triggerRecord.triggerType].title
    elements.codeReceiveMainButton.dataset.matomoSku = issueRecord.rewardCode
    elements.codeReceiveMainButton.dataset.matomoIndex = triggerRecord.triggerType

    elements.copyBtn.dataset.matomoSize = couponText
    elements.copyBtn.dataset.matomoColor = this.triggerTypeObj[triggerRecord.triggerType].title
    elements.copyBtn.dataset.matomoSku = issueRecord.rewardCode
    elements.copyBtn.dataset.matomoIndex = triggerRecord.triggerType

    // 处理集合链接
    if (entitledCollectionUrlList && entitledCollectionUrlList.length > 0) {
      elements.collectionBtn.href = entitledCollectionUrlList[0]
      elements.codeReceiveBox.classList.add('have-collection')
      elements.collectionBtn.classList.remove('hide')
    } else {
      elements.collectionBtn.classList.add('hide')
      elements.codeReceiveBox.classList.remove('have-collection')
    }
  }

  updateTriggerDisplay(containerEl, triggerRecord) {
    const { rewardValueType, rewardValue, rewardPrerequisiteMinSubtotal } = triggerRecord
    const codeNumEl = containerEl.querySelector('.code-modal-main-coupon-code-num')
    const codeTextEl = containerEl.querySelector('.code-modal-main-coupon-code-text')
    const couponText = this.formatCouponText(rewardValueType, rewardValue, rewardPrerequisiteMinSubtotal)
    const buttonEl = containerEl.querySelector('.cart-coupon-modal-main-button')
    const descEl = containerEl.querySelector('.cart-coupon-modal-main-desc')
    buttonEl.dataset.matomoSize = couponText
    buttonEl.dataset.matomoColor = this.triggerTypeObj[triggerRecord.triggerType].title
    buttonEl.classList.remove('hide')
    if (rewardValueType === 1) {
      codeNumEl.textContent = `${rewardValue * 100}%`
      codeTextEl.textContent = rewardPrerequisiteMinSubtotal ? `OFF $${rewardPrerequisiteMinSubtotal}+` : 'OFF'
      descEl && (descEl.textContent = `Subscribe to our newsletter & Grab ${rewardValue * 100}% OFF`)
    } else if (rewardValueType === 2) {
      codeNumEl.textContent = `$${rewardValue}`
      codeTextEl.textContent = rewardPrerequisiteMinSubtotal ? `OFF $${rewardPrerequisiteMinSubtotal}+` : ''
      descEl && (descEl.textContent = `Subscribe to our newsletter & Grab $${rewardValue} OFF`)
    }
  }

  formatCouponText(rewardValueType, rewardValue, minSubtotal) {
    if (rewardValueType === 1) {
      return `${rewardValue * 100}%${minSubtotal ? ` OFF $${minSubtotal}+` : 'OFF'}`
    }
    return `$${rewardValue}${minSubtotal ? ` OFF $${minSubtotal}+` : ''}`
  }

  bindQuponModalMainButton() {
    this.elements.quponModalMainButtons?.forEach(item => {
      const handler = item.classList.contains('receive')
        ? async () => {
          await navigator.clipboard.writeText(this.lastRecordData.lastValidIssueRecordResponse.rewardCode)
          this.closeQuponModal()
        }
        : () => this.handleQuponModalMainButtonClick()

      item.addEventListener('click', handler)
    })
  }

  bindCopyBtn() {
    this.elements.copyBtn.classList.remove('copied')
    this.elements.copyBtn.addEventListener('click', async (e) => {
      try {
        await navigator.clipboard.writeText(this.lastRecordData.lastValidIssueRecordResponse.rewardCode)
        this.elements.copyBtn.classList.add('copied')
      } catch (error) {
      }
    })
  }

  setCartDrawerCouponBanner() {
    const { lastValidTriggerRecordResponse: triggerRecord } = this.lastRecordData
    if (!triggerRecord) return

    const couponEl = this.elements.transactionOptimizationCoupon
    const titleEl = couponEl.querySelector('.drawer__cart-transaction-optimization-coupon-title')
    titleEl.innerHTML = this.triggerTypeObj[triggerRecord.triggerType].title
    couponEl.classList.remove('hide')

    this.timers.cartDrawer = this.setTimeCountDown(
      '#CartDrawer .drawer__cart-transaction-optimization-coupon-countdown',
      triggerRecord.triggerEndTime,
      'cartDrawer'
    )

    const contentText = couponEl.querySelector('.drawer__cart-transaction-optimization-coupon-text')
    contentText.innerHTML = '&nbsp;' + this.formatCouponText(
      triggerRecord.rewardValueType,
      triggerRecord.rewardValue,
      triggerRecord.rewardPrerequisiteMinSubtotal
    )
  }

  async handleQuponModalMainButtonClick() {
    if (this.loadingStatus.issueRecord) return

    const containerEl = this.elements.quponModal.querySelector(
      `.cart-coupon-modal-main-item.${this.triggerTypeObj[this.lastRecordData.lastValidTriggerRecordResponse.triggerType].value}`
    )

    const errorEl = containerEl.querySelector('.cart-coupon-modal-main-error')
    errorEl.classList.add('hide')

    try {
      this.loadingStatus.issueRecord = true
      this.query('operation/behaviorReward/create/issueRecord', {
        subscribeEmail: MicasManager.customer.email,
        triggerRecordId: this.lastRecordData.lastValidTriggerRecordResponse.recordId
      }, 'post').then(res => {
        this.lastRecordData.lastValidIssueRecordResponse = res.data
        this.setCartDrawerCouponBanner()
        clearInterval(this.timers.cartQuponModal)
        this.timers.cartQuponModal = null
        this.cartQuponModalOpen()

      }).catch(error => {
        errorEl.classList.remove('hide')
        errorEl.textContent = error.message
      }).finally(() => {
        this.loadingStatus.issueRecord = false
      })
    } catch (error) {
      console.debug('处理按钮点击失败:', error)
    }
  }

  closeQuponModal() {
    this.wrapper.dataset.allowTrigger = 'false'
    this.elements.quponModal.style.display = 'none'
    this.wrapper.dataset.computedTriggerType = 'null'
    clearInterval(this.timers.cartQuponModal)
    this.timers.cartQuponModal = null
  }

  async getLastRecord() {
    const data = await this.query('operation/behaviorReward/get/lastRecord').catch(error => {
      console.debug('获取上次记录失败:', error)
    })
    if (data.code === 200) {
      this.lastRecordData = data.data
      this.lastRecordData.allowTrigger = this.lastRecordData.allowTrigger ? 'true' : 'false'
    }
    return this.lastRecordData
  }

  async getSubscribeStatus() {
    const res = await this.query('user/customer/home').catch(error => {
      console.debug('获取订阅状态失败:', error)
    })
    return res?.data?.emailSubscriptionStatus
  }

  setTimeStatus(status) {
    this.wrapper.dataset.timeStatus = status
  }

  async setAllowTriggerStatus() {
    await this.getLastRecord()
    if (this.lastRecordData.allowTrigger === 'true') {
      this.wrapper.dataset.allowTrigger = 'true'
    } else {
      this.wrapper.dataset.allowTrigger = 'false'
      this.setCartDrawerCouponBanner()
    }
  }

  async setSubscribeStatus() {
    const subscribeStatus = await this.getSubscribeStatus()
    // subscribed不等于2，就算是未订阅
    this.wrapper.dataset.subscribeStatus = subscribeStatus === 2 ? 'subscribed' : 'not-subscribed'
  }

  setTimeCountDown(containerSelector, timestamp, type) {
    const containerEl = document.querySelector(containerSelector)
    if (!containerEl) {
      return null
    }

    // 清除已存在的定时器
    if (this.timers[type]) {
      clearInterval(this.timers[type])
      this.timers[type] = null
    }

    containerEl.innerHTML = ''
    const endTime = new Date(Number(timestamp))
    const now = new Date()
    const diff = endTime.getTime() - now.getTime()
    if(diff <= 0) return
    const updateTargets = []

    const createCountdownUI = (type === 'cartQuponModal')
      ? this.createCartQuponModalCountdownUI
      : this.createCartDrawerCountdownUI

    createCountdownUI(containerEl, updateTargets)

    const updateDisplay = () => {
      const now = new Date().getTime()
      let distance = endTime.getTime() - now

      if (distance <= 0) {
        // 清除定时器
        clearInterval(this.timers[type])
        this.timers[type] = null

        // 更新显示
        const defaultValue = type === 'cartQuponModal' ? '0' : '00'
        updateTargets.forEach(span => span.textContent = defaultValue)

        // 处理倒计时结束
        if (type === 'cartDrawer') {
          this.elements.transactionOptimizationCoupon.classList.add('hide')
        }
        this.elements.quponModal.style.display = 'none'

        // 更新数据
        this.getLastRecord()

        // 重置状态
        this.setTimeStatus('false')
        this.wrapper.dataset.allowTrigger = 'false'
        this.wrapper.dataset.computedTriggerType = 'null'
        return
      }

      const timeValues = this.calculateTimeValues(distance)
      this.updateCountdownDisplay(type, updateTargets, timeValues)
    }

    // 立即执行一次
    updateDisplay()

    // 设置定时器
    this.timers[type] = setInterval(updateDisplay, 1000)
    return this.timers[type]
  }

  createCartQuponModalCountdownUI(containerEl, updateTargets) {
    ['N', 'N', ':', 'N', 'N', ':', 'N', 'N'].forEach(item => {
      const span = document.createElement('span')
      if (item === 'N') {
        span.textContent = '0'
        span.classList.add('unit-num')
        updateTargets.push(span)
      } else {
        span.textContent = item
        span.classList.add('separator')
      }
      containerEl.appendChild(span)
    })
  }

  createCartDrawerCountdownUI(containerEl, updateTargets) {
    ['hours', 'minutes', 'seconds'].forEach((unit, index) => {
      const numSpan = document.createElement('span')
      numSpan.textContent = '00'
      numSpan.classList.add('unit-num')
      updateTargets.push(numSpan)
      containerEl.appendChild(numSpan)

      if (index < 2) {
        const separatorSpan = document.createElement('span')
        separatorSpan.textContent = ':'
        separatorSpan.classList.add('separator')
        containerEl.appendChild(separatorSpan)
      }
    })
  }

  calculateTimeValues(distance) {
    const hours = Math.floor(distance / (1000 * 60 * 60))
    distance %= (1000 * 60 * 60)
    const minutes = Math.floor(distance / (1000 * 60))
    distance %= (1000 * 60)
    const seconds = Math.floor(distance / 1000)

    return {
      hours: this.formatTwoDigits(hours),
      minutes: this.formatTwoDigits(minutes),
      seconds: this.formatTwoDigits(seconds)
    }
  }

  updateCountdownDisplay(type, updateTargets, timeValues) {
    if (type === 'cartQuponModal') {
      const allNumbersString = timeValues.hours + timeValues.minutes + timeValues.seconds
      updateTargets.forEach((span, index) => {
        span.textContent = allNumbersString.charAt(index)
      })
    } else {
      updateTargets[0].textContent = timeValues.hours
      updateTargets[1].textContent = timeValues.minutes
      updateTargets[2].textContent = timeValues.seconds
    }
  }

  formatTwoDigits(num) {
    return num < 10 ? `0${num}` : `${num}`
  }

}
class ScrollLoad{
  constructor(obj={}) {
    this.data=[];
    this.observer=null;
    this.container=obj?.container|| '.collection-content .collection-grid__wrapper .grid';
  }
  init(){
    this.status='loaded';
    this.page= 1;
    this.page_max=2;
    this.url = location.href;
    const tags = new URLSearchParams(window.location.search).get('tags');
    this.msinfluencerselection = !!tags && tags === 'msinfluencerselection'
    const statusEL= document.querySelector('#loading_status');
    if(statusEL){
      this.page_max = Number(statusEL.dataset.pages);
    }
    const sortByStr = this.getUrlParam('sort_by') || ''
    this.sort_by = sortByStr.split(',')
    this.current_sort_by = sortByStr.split(',')
    this.rendspu=this.sort_by.slice(0,20).map(item=>item.toLowerCase())
    this.bind();
  }
  bind(){
    // 交叉观察器 替代滚动监听
    const self = this
    if(this.observer){
      this.observer.unobserve(this.loadingFlag);
    }
    let options = {
      root:null,
      rootMargin: '0px 0px 1000px 0px',
      threshold: 0
    }
    const loadingFlag = document.querySelector('#loading_flag');
    if(!loadingFlag) return;
    this.loadingFlag = loadingFlag;
    this.observer = new IntersectionObserver((entries)=>{
      // 如果不可见，就返回
      if (entries[0].intersectionRatio <= 0) return;
      self.nextPage()
    }, options);

    this.observer.observe(this.loadingFlag);
  }
  nextPage(){
    if(this.status !== 'loaded'){
      return false
    }
    this.setStatus('loading')
    this.getProducts(this.page + 1)
  }
  getProducts(page){
    this.page = page;
    //后端渲染时 如果sortby 大于20个则不会渲染原有页码产品,所以需要--
    if(this.current_sort_by.length>=20){
      //大于20个则切割掉前面20个,前面20个已经随页面第一次加载了
      this.current_sort_by = this.current_sort_by.slice(20)
      this.page--
    }
    const newSortBy = this.current_sort_by.join(',');
    //替换掉spu
    let newFetchUrl = this.replaceUrlSort(newSortBy);

    if(newFetchUrl.includes('?')){
      newFetchUrl += `&view=ajax2&page=${this.page}`
    }else{
      newFetchUrl += `?view=ajax2&page=${this.page}`
    }
    fetch(newFetchUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to load collection page: HTTP ${response.status}`)
        }
        return response.text()
      })
      .then(data=>{
        const html = new DOMParser().parseFromString(data, 'text/html');
        const grid = html.querySelector('#CollectionAjaxContent .collection-grid__wrapper');
        if (!grid) {
          throw new Error('Failed to load collection page: invalid response')
        }
        if(this.page >= this.page_max){
          this.setStatus('end')
        }else {
          this.setStatus('loaded')
        }
        this.updateMaxPage(html)
        const products = html.querySelectorAll('#CollectionAjaxContent .collection-grid__wrapper .grid__item.grid-product');
        this.rendProducts(products)
      })
      .catch(e=>{
        console.debug('fetch error:', e)
        this.page--;
        this.setStatus('error')
      })
  }
  replaceUrlSort(newSortBy){
    const sortByStr = this.getUrlParam('sort_by') || '';
    const enSortByStr = encodeURIComponent(sortByStr);
    let url =  this.url.replace(sortByStr,encodeURIComponent(newSortBy));
    url =  url.replace(enSortByStr,encodeURIComponent(newSortBy));
    return url;
  }
  rendProducts(products){
    const fragment = document.createDocumentFragment()
    if (products.length){
      products.forEach((product)=>{
        const name = product.dataset.contentName || 'ajax';
        const action = product.dataset.matomoAction || 'ajax';
        const spu = product.dataset.productHandle;
        product.dataset.contentName = name.replace('ajax',`collection_${this.page}`)
        product.dataset.matomoAction = action.replace('ajax',"collection_{{ collection.handle }}")
        // 如果是PC端
        if(window.matchMedia("(min-width: 769px)").matches){
          //  查找所有A标签
          const aList = product.querySelectorAll('.collection-grid__wrapper .grid a');
          // 添加打开属性
          aList.forEach(a => {
            if(a.classList.contains('turbolink')) {
              a.removeAttribute('target');
            } else{
              a.setAttribute('target', '_blank');
            }
          })
        }
        if(!spu || !this.rendspu.includes(spu.toLowerCase())  ){
          this.colorSwatchHovering(product)
          fragment.appendChild(product)
          //把已经加载的spu push进去数组
          if(spu){
            this.rendspu.push(spu.toLowerCase())
          }
        }

        // 如果搜索参数携带tags=msinfluencerselection,则透传到详情页
        if (this.msinfluencerselection) {
          const aList = product.querySelectorAll('.grid-product__link');
          aList.forEach(a => {
            if (!a.href) {
              return;
            }
            const url = new URL(a.href, window.location.origin);
            url.searchParams.set('tags', 'msinfluencerselection');
            a.href = `${url.pathname}${url.search}${url.hash}`;
          })
        }
      })
      const rendLength = fragment.querySelectorAll('.grid__item.grid-product').length;
      if(typeof window.appendMfrom === 'function'){
        window.appendMfrom(fragment)
      }
      const box = document.querySelector(this.container);
      if(box){
        if(typeof window.theme.reinitProductGridItem == 'function'){
          window.theme.reinitProductGridItem(fragment);
        }
        box.appendChild(fragment)
        if (AOS) {AOS.refreshHard()}
        document.dispatchEvent(new CustomEvent('collection:fetchMore'));
      }
      if(rendLength<12 && this.status !== 'end'){
        this.setStatus('loaded')
        this.nextPage()
      }
    }else if (this.status !== 'end')  {
      this.setStatus('loaded')
      this.nextPage()
    }
  }
  setStatus(tag) {
    this.status = tag
    const statusEL= document.querySelector('#loading_status');
    if(tag && statusEL) {
      statusEL.dataset.status=tag
    }
  }
  getUrlParam(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    let search = decodeURIComponent(window.location.search)
    let r = search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
  }
  updateMaxPage(html){
    const pageEndEl = html.querySelector('#pageEnd')
    if(pageEndEl){
      const max = pageEndEl.dataset?.pages || 2
      this.max_page = Number(max)
    }
  }
  colorSwatchHovering(item) {
    const colorImages = item.querySelectorAll('.grid-product__color-image')
    if (!colorImages.length) {
      return
    }
    item.querySelectorAll('.color-swatch--with-image').forEach((swatch) => {
      swatch.addEventListener('mouseenter', function () {
        const id = swatch.dataset.variantId
        const image = swatch.dataset.variantImage
        const el = item.querySelector('.grid-product__color-image--' + id)
        el.style.backgroundImage = 'url(' + image + ')'
        el.classList.add('is-active')
      })
      swatch.addEventListener('mouseleave', function () {
        const id = swatch.dataset.variantId
        const el = item.querySelector('.grid-product__color-image--' + id);
        el.classList.remove('is-active')
      })
    })
  }
}

function initScrollLoad() {
  if (!document.querySelector('#loading_flag')) return;
  let scrollLoad = null;
  if (document.body.classList.contains('template-collection')) {
    scrollLoad = new ScrollLoad();
  } else if (document.body.classList.contains('template-search')) {
    scrollLoad = new ScrollLoad({
      container: '#CollectionAjaxContent .collection-grid__wrapper .grid'
    });
  }
  if (scrollLoad) {
    scrollLoad.init();
  }
}

function initShareDrawer() {
  if (!theme.config.bpSmall) return;
  let copyLinkEls = document.querySelectorAll('.social-sharing .copy-link');
  copyLinkEls.length && copyLinkEls.forEach(item => {
    item.addEventListener('click',() => {
      navigator.clipboard.writeText(item.dataset.productTitle + ' ' + item.dataset.productUrl)
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  new MicasTransactionOptimizationManager(cartDrawer?.drawer.drawer, true)
  const productWrapper = document.querySelector('#MainContent .product-section')
  if (productWrapper){
    new MicasWishProductStateManager(productWrapper)
  }
  initScrollLoad();
  initShareDrawer();
})

document.addEventListener('quickview:loaded', (ev) => {
  const sectionId = ev.detail.productId;
  const productWrapper = document.querySelector(`.modal--is-active .product-section[data-section-id="${sectionId}"]`)
  if (productWrapper){
    new MicasWishProductStateManager(productWrapper)
  }
})

document.addEventListener('collection:reloaded', function() {
  initScrollLoad();
});

document.addEventListener('DOMContentLoaded', function () {
  const deviceTypeInput = document.querySelector('input[name="attributes[deviceType]"]');
  if (!deviceTypeInput) return;
  deviceTypeInput.value = window.matchMedia('(max-width: 768px)').matches
    ? 'mobile'
    : 'desktop';
});

class MicasExpandableCopy extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('[data-expandable-copy-content]');
    this.toggle = this.querySelector('[data-expandable-copy-toggle]');
    this.isExpanded = false;
    this.resizeFrame = null;
    this.handleToggle = this.handleToggle.bind(this);
    this.scheduleRefresh = this.scheduleRefresh.bind(this);
  }

  connectedCallback() {
    if (!this.content || !this.toggle) return;

    this.moreLabel = this.dataset.moreLabel || 'More';
    this.lessLabel = this.dataset.lessLabel || 'Less';
    this.toggle.addEventListener('click', this.handleToggle);

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.scheduleRefresh);
      this.resizeObserver.observe(this);
    } else {
      window.addEventListener('resize', this.scheduleRefresh);
    }

    this.refresh();
    document.fonts?.ready.then(this.scheduleRefresh);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.handleToggle);
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.scheduleRefresh);
    cancelAnimationFrame(this.resizeFrame);
  }

  handleToggle() {
    this.isExpanded = !this.isExpanded;
    this.render();
  }

  scheduleRefresh() {
    cancelAnimationFrame(this.resizeFrame);
    this.resizeFrame = requestAnimationFrame(() => this.refresh());
  }

  refresh() {
    if (!this.content || !this.toggle) return;

    const shouldRestoreExpanded = this.isExpanded;
    this.classList.add('is-measuring');
    const hasOverflow = this.content.scrollHeight > this.content.clientHeight + 1;
    this.classList.remove('is-measuring');
    this.classList.toggle('has-overflow', hasOverflow);
    this.isExpanded = hasOverflow && shouldRestoreExpanded;
    this.render();
  }

  render() {
    this.classList.toggle('is-expanded', this.isExpanded);
    this.toggle.hidden = !this.classList.contains('has-overflow');
    this.toggle.setAttribute('aria-expanded', String(this.isExpanded));
    this.toggle.textContent = this.isExpanded ? this.lessLabel : this.moreLabel;
  }
}

if (!customElements.get('micas-expandable-copy')) {
  customElements.define('micas-expandable-copy', MicasExpandableCopy);
}
